module.exports = {
  common: {
    FindUs: 'Découvrez nos produits et services',

    registeredAccount: 'Enregistrer un compte NTL',
    unlock: 'Débloquez NTL! Découvrez le pouvoir de l’anonymat',
    invitation: 'Inviter un ami à NTL',
    closeTheDeal: 'Clôture de la première transaction',

    sloganthree: 'Bienvenue à ntl!',
    slogantwo: 'Découvrez l’univers unique d’ntl',
    slogantwo2: 'Mécanisme transparent, sécurité sans souci',
    currencySelection: 'Tableaux',
    chart: 'Graphique',
    details: 'Détails',
    entrust: 'Mandat',
    login: "S'identifier",
    register: "S'inscrire",
    indexplaceholde: 'email',
    loginregister: "S'identifier S'enregistrer",
    logout: 'Se déconnecter',
    tip: 'Pointe',
    signupnow: 'vous maintenant',
    logintip: "s'il vous plait Connectez-vous d'abord",
    expect: "Attendez-vous à l'attente!",
    delete: "Êtes-vous d'accord pour supprimer?",
    nodata: 'Pas de données',
    set: 'Ensemble',
    update: 'Modifier',
    slogan: 'Les 50 meilleurs échanges de devises numériques au monde',
    subslogan: "L'organisme d'État garantit la sécurité des actifs",
    more: 'Plus',
    please: "S'il vous plaît",
    pleaseselect: 'Sélectionner',
    searchplaceholder: 'Entrez le symbole de la pièce ...',
    searchplaceholderswap: 'Entrez le symbole de swap ...',
    loading: 'Chargement...',
    close: 'Fermer',
    ok: "D'ACCORD",
    fillComplete: 'Veuillez remplir les informations complètes',
    inputpleaseselect: 'Veuillez entrer',
    showDetail: 'Voir les détails',
  },
  header: {
    index: 'Accueil',
    otc: 'OTC',
    trade: 'Commerce',
    exchange: 'Échange',
    xiaoxi: 'Message',
    kefu: 'Aidez-moi',
    login: "S'IDENTIFIER",
    register: "S'INSCRIRE",
    asset: 'ACTIF',
    otcOrder: 'ORDRE',
    ucenter: 'COMPTE',
    service: 'Annonce',
    downloadapp: "Scannez le code pour le téléchargement et l'installation",
    appdownlaod: "Télécharger l'application",
    usercenter: 'Centre utilisateur',
    helpcenter: "CENTRE D'AIDE",
    aboutus: 'À propos',
    partner: 'Partenaire',
    bzb: 'BZB ECO',
    assetmanage: 'La finance',
    trademanage: 'Échange',
    activity: 'Foudre',
    lab: 'NTL Lab',
    ctc: 'Échange C2C',
    labdetail: 'NTL Lightning Lab',
    invite: 'Partenaire promoteur',
    whitepaper: 'Papier blanc',
    scandownload: "Télécharger l'appli",
    innovationmanage: 'Innovation',
    swap1: 'Swap (PRO)',
    swap2: 'Swap (Ex)',
    swap3: 'CFD',
    swap4: 'Seconde',
    cexchange: 'QuikExchange',
    option: "Contrat d'option",
    news: 'Nouvelles',
    swapExchange: 'transaction de contrat',
    finance: 'Services financiers',
    fiatCurrency: 'Acheter des cryptos',
  },
  sectionPage: {
    global_leader: 'Premier échange mondial de devises numériques',
    Professional:
      'Le trading professionnel et l’opération simple vous permettent de comprendre facilement le trading numérique',
    showMore: 'Voir plus',
    brandDesc6:
      "Uzx dispose d'une fonction d'accès instantané aux actifs de blockchain, d'une technologie de partage d'adresses Multi - devises et d'une protection d'authentification de sécurité multiple, ainsi que d'un faible coût de transaction et de retrait des actifs de blockchain dans l'industrie.",
    brandDesc5:
      "La solution technique d'ntl est basée sur Google Cloud et Amazon AWS, qui peut efficacement prévenir les attaques DDOS et soutenir la séparation dynamique et statique des données. Prise en charge de la mise en cache des données Hotspot, prise en charge de la reprise après sinistre hors site, prise en charge de l'expansion parallèle, architecture technologique de pointe mondiale pour assurer la sécurité des transactions des utilisateurs.",
    brandDesc4:
      "Uzx dispose actuellement d'un service d'actifs cryptés à guichet unique, y compris la monnaie, le contrat perpétuel, le spot, l'option, le prêt financier et d'autres services d'actifs cryptés, et prend en charge plusieurs versions linguistiques, y compris le chinois / anglais / japonais / coréen / etc.",
    brandDesc3:
      "Uzx s'engage à être une bourse internationale d'actifs de blockchain sûre, stable, pratique, équitable et digne de confiance, afin de garantir pleinement la sécurité de l'information sur les transactions des utilisateurs et la sécurité des actifs.",
    brandTitle2: "Service d'actifs cryptographiques à guichet unique",
    brandTitle1: 'International Digital Assets Derivatives Exchange',
    ptaqTitle: 'Sécurité de la plateforme',
    ptaqContent:
      "L'algorithme de hachage est utilisé pour crypter la principale authentification de sécurité au monde",
    ptslTitle: 'Force de la plate-forme',
    ptslContent: 'La plus grande plateforme de trading bitcoin au monde',
    newsTitle: "Centre d'Information",
    brandTitle: 'À propos de NTL',
    brandDetail: 'Honnête | Juste | Enthousiasme | Ouvert',
    brandDesc1:
      "NTL a été fondé par un groupe de premiers participants et geeks Bitcoin. Les principaux membres de l'équipe sont issus d'entreprises bien connues telles que Google, Microsoft, Alibaba, Tencent, etc. dans le fonctionnement du produit Internet. ",
    brandDesc2:
      "NTL est situé dans le fournisseur de services de base de la chaîne de blocs, dédié à fournir une plate-forme de négociation d'actifs cryptés de haute qualité pour les utilisateurs mondiaux, adhérant au principe de base de« NE PAS ÊTRE MAL », en garantissant un service honnête, juste et enthousiaste aux clients , et accueillant tous les partenaires / projets qui sont bénéfiques aux intérêts fondamentaux des utilisateurs avec une attitude ouverte. ",
    gettingstart: 'HOT | Guide du débutant',
    officialstart: 'Service Client Officiel NTL',
    oneminutebuy: 'Currency transaction',
    oneminutebuytips: 'échanger un actif numérique contre un autre',
    baseknow: 'Contrats perpétuels',
    baseknowtips:
      't + 0 transaction bidirectionnelle de marchandises virtuelles comme contrat de troc',
    baseexchange: 'option contract',
    baseexchangetips: "Est un dérivé d'actifs numériques",
    usersocial: 'QUICK EXCHANGE',
    usersocialtips: 'QUICK EXCHANGE Digital assets',
    mainboard: 'Carte principale',
    preview: 'Précédent',
    nextpage: 'Prochain',
    downloadwhite: 'Télécharger le livre blanc',
  },
  nav: {
    ptjy: 'Trading sur plateforme',
    ptaq: 'Sécurité de la plateforme',
    ptsl: 'Force de la plate-forme',
    xwzx: "Centre d'Information",
    fabu: 'La publicité',
  },
  progress: {
    already: 'Je dois creuser',
    total: 'Quantité de minerai excavable 6 milliards de BHB',
  },
  service: {
    USDT: 'USDT',
    BTC: 'BTC',
    ETH: 'ETH',
    CUSTOM: 'Favoriser',
    COIN: 'Pièce de monnaie',
    symbol: 'Paire de transactions',
    favor: 'Favoriser',
    NewPrice: 'Dernier',
    ExchangeNum: 'Montant',
    FeePercent: 'Taux de financement',
    Change: 'Changement',
    OpenPrice: 'Prix ouvert',
    PriceTrend: 'Tendance des prix',
    Operate: 'Exploiter',
    Exchange: 'Échange',
    trading: 'Échange',
    high: 'Plus haute',
    low: 'Inférieur',
  },
  exchange: {
    loginBuy: 'Achat après connexion (BTC)',
    loginOut: 'Vendre après la connexion (BTC)',
    coin: 'Pièce de monnaie',
    symbol: 'Paire de transactions',
    lastprice: 'Dernier',
    daychange: 'Changement',
    market: 'Marchés',
    favorite: 'Marqué',
    do_favorite: 'Collecté',
    cancel_favorite: 'Annuler collecté',
    type: 'Type',
    dealamount: 'Montant fini',
    high: 'Haute',
    low: 'Faible',
    vol: 'Vol 24H',
    buy: 'Acheter',
    sell: 'Vendre',
    limited_price: 'Prix limité',
    market_price: 'Prix du marché',
    fees_rate: 'tarif des frais',
    balance: 'soldes',
    or: 'ou',
    starttrade: 'Échangeons maintenant!',
    canuse: 'Disponible',
    recharge: 'Dépôt',
    buyprice: "Prix d'achat",
    buynum: 'Acheter le montant',
    amount: 'Montant',
    buyin: 'Acheter',
    disablebuyin: 'Achat sur le marché désactivé',
    buytip: 'Achat optimal',
    sellprice: 'Prix de vente',
    sellnum: 'Montant de la vente',
    sellout: 'Vendre',
    disablesellout: 'Vente sur le marché désactivée',
    selltip: 'Vente optimale',
    curdelegation: 'Délégué',
    hisdelegation: "Délégué d'histoire",
    realtransaction: 'Métiers du marché',
    num: 'Montant',
    price: 'Prix',
    direction: 'Direction',
    time: 'Temps',
    stall: 'Décrochage',
    total: 'Total',
    traded: 'Terminé',
    action: 'Action',
    undo: 'Annuler',
    delegationnum: 'Montant délégué',
    done: 'Terminé',
    status: 'Statut',
    finished: 'Fini',
    canceled: 'Annulé',
    parted: 'Séparé',
    tip: 'Pointe',
    buyamounttip: "saisir le montant de l'achat",
    buyamounttipwarning: 'acheter montant pas plus',
    success: 'Soumettre un succès!',
    pricetip: "saisir le prix d'achat",
    pricetipwarning: "prix d'achat pas plus",
    sellamounttip: 'saisir le montant de la vente',
    sellamounttipwarning: 'vendre le montant pas plus',
    sellpricetip: 'saisir le prix de vente',
    sellpricetipwarning: 'prix de vente pas plus',
    undotip: "Confirmer l'annulation?",
    cancelsuccess: 'Annulation de la commande réussie',
    marketprice: 'Prix du marché',
    expand: {
      time: 'temps',
      price: 'prix',
      amount: 'montant',
      fee: 'frais',
    },
    realtime: 'temps réel',
    kline: 'KLine',
    depth: 'Profondeur',
    publishstate0: 'Il est sur le point de commencer. Veuillez patienter ....',
    publishstate1: 'Il est sur le point de se terminer. Veuillez patienter ...',
    publishstate2: 'Consolidation de la commande, veuillez patienter ...',
    publishstate3: "La consolidation est terminée, merci d'échanger librement ...",
    publishdetail: 'Plus de détails',
    publishprice: 'Prix',
    publishamount: 'Montant',
    publishcounttxt0: 'Commencer après',
    publishcounttxt1: 'Fin après',
    publishcounttxt2: 'Libre-échange après',
    publishcounttxt3: 'Activité terminée!',
    dateTimeDay: 'RÉ',
    dateTimeHour: 'H',
    dateTimeMinutes: 'M',
    dateTimeSeconds: 'S',
    moredetail: 'Voir plus',
  },
  swap: {
    contract: 'Contrat',
    swapindex: 'SWAP',
    coin: 'Pièce',
    symbol: 'Paire de pièces',
    volume: 'Le volume',
    lastprice: 'Dernier',
    daychange: 'Changement',
    market: 'Marchés',
    favorite: 'Marqué',
    do_favorite: 'Collecté',
    cancel_favorite: 'Annuler collecté',
    type: 'Type',
    dealamount: 'Montant fini',
    high: 'Haute',
    low: 'Faible',
    vol: 'Vol 24H',
    buy: 'Acheter',
    sell: 'Vendre',
    limited_price: 'Prix limité',
    market_price: 'Prix du marché',
    spot_price: 'Prix de déclenchement',
    fees_rate: 'taux de frais',
    balance: 'soldes',
    or: 'ou',
    starttrade: 'Échangeons maintenant!',
    canuse: 'Disponible',
    recharge: 'Dépôt',
    buyprice: "Prix d'achat",
    buynum: "Montant d'achat",
    amount: 'Montant',
    buyin: 'Acheter',
    disablebuyin: 'Achat sur le marché désactivé',
    buytip: 'Achat optimal',
    sellprice: 'Prix de vente',
    sellnum: 'Montant de la vente',
    sellout: 'Vendre',
    disablesellout: 'Vente sur le marché désactivée',
    selltip: 'Vente optimale',
    curdelegation: 'Délégué',
    hisdelegation: "Délégué d'histoire",
    realtransaction: 'Métiers du marché',
    num: 'Montant',
    price: 'Prix',
    direction: 'Direction',
    time: 'Temps',
    stall: 'Décrochage',
    total: 'Total',
    traded: 'Terminé',
    action: 'Action',
    undo: 'Annuler',
    delegationnum: 'Montant délégué',
    done: 'Terminé',
    status: 'Statut',
    finished: 'Fini',
    canceled: 'Annulé',
    parted: 'Séparé',
    tip: 'Pointe',
    buyamounttip: "saisir le montant de l'achat",
    buyamounttipwarning: 'acheter le montant pas plus',
    success: 'Soumettre un succès!',
    pricetip: "saisir le prix d'achat",
    pricetipwarning: "prix d'achat pas plus",
    sellamounttip: 'saisir le montant de la vente',
    sellamounttipwarning: 'vendre le montant pas plus',
    sellpricetip: 'saisir le prix de vente',
    sellpricetipwarning: 'prix de vente pas plus',
    undotip: "Confirmer l'annulation?",
    cancelsuccess: 'Annulation de la commande réussie',
    marketprice: 'Prix du marché',
    expand: {
      time: 'temps',
      price: 'prix',
      amount: 'montant',
      fee: 'frais',
    },
    realtime: 'temps réel',
    kline: 'KLine',
    depth: 'Profondeur',
    open: 'Ouvert',
    close: 'Fermer',
    latestdeal: 'Dernière offre',
    myswapaccount: 'Mon compte Swap',
    accountmode: 'Pattren',
    accountmargin: 'Effet de levier',
    accountquanyi: 'Équité',
    profitandloss: 'P / L non réalisé',
    principalAmount: 'Marge disponible',
    positionAmount: 'Marge utilisée',
    frozenAmount: 'Marge gelée',
    principalRate: 'Ratio de marge',
    zijinhuazhuan: 'Transfert',
    up: 'L',
    down: 'S',
    canup: 'Max. L',
    candown: 'Max. S',
    cancloseup: 'Max (S)',
    canclosedown: 'Max (L)',
    openup: 'Open Long',
    opendown: 'Open Short',
    closeup: 'Fermer court',
    closedown: 'Fermer longue',
    currentposition: 'Postes ouverts',
    assetsdetail: 'Transactions',
    marginMode1: 'Fixe',
    marginMode2: 'Traverser',
    modifyMarginModeTitle: 'Modifier le mode de marge du compte',
    modifyLeverage: "Ajuster l'effet de levier",
    moredetail: 'Voir plus',
    shareNumber: 'Cont',
    entrustprice: 'Prix',
    triggleprice: 'Déclencheur',
    openvolume: 'Volume long',
    closevolume: 'Volume court',
    triggleplaceholder: 'Le prix par défaut est le prix du marché',
    marketpriceplaceholder: 'Se négociera au meilleur prix',
    levmaxtip: "L'effet de levier ne doit pas dépasser le Max",
    levmintip: "L'effet de levier ne doit pas être inférieur au Min",
    marginModeSuccessTip: 'Modifier le succès.',
    noenoughbalance: 'Solde insuffisant',
    pleaseinputopenvolume: 'Le volume doit être supérieur à 0',
    pleaseinputcorrectopenvolume: 'Veuillez saisir le volume correct',
    pleaseinputrightentrustprice: "Prix correct d'entrée Plwase",
    noenoughposition: 'Position insuffisante',
    pleaseinputclosevolume: 'Le volume doit être supérieur à 0',
    pleaseinputcorrectclosevolume: 'Veuillez saisir le volume correct',
    pos_Pl: 'PL.',
    pos_Ratio: 'Rapport PL',
    pos_pos: 'Position',
    pos_canClose: 'Position Ava',
    pos_openPrice: 'Prix Ouvert',
    pos_leverage: 'Effet de levier',
    pos_margin: 'Cur Margin',
    pos_mRatio: 'Ratio de marge',
    pos_cmRatio: 'Mainten Ratio',
    pos_long: 'Longue',
    pos_short: 'Court',
    ent_entrustType: 'Ouvrir fermer',
    ent_direction: 'Direction',
    ent_type: 'Type',
    ent_trigglePrice: 'Prix de déclenchement',
    ent_entrustPrice: 'Prix de confiance',
    ent_tradedPrice: 'Prix négocié',
    ent_margin: 'Marge',
    ent_volume: 'Le volume',
    ent_status: 'Statut',
    ent_status1: 'Confiant',
    ent_status2: 'Annulé',
    ent_status3: 'Entrust Failed',
    ent_status4: 'Négociés',
    ent_statusblast: 'Blast',
    ent_pl: 'PL',
    ent_fee: 'Frais',
    triggerpriceshouldbigger: 'Le prix de déclenchement doit être supérieur à 0',
  },
  second: {
    balance: 'Équilibre',
    profitability: 'Rentabilité',
    opentime: 'Temps ouvert',
    transactionMode: 'Mode de transaction',
    currentPosition: 'Position actuelle',
  },
  ctc: {
    title: 'Vente en un clic ● Garantie de la plateforme ● Sécurité',
    desc: "Les actifs cryptographiques sont gérés par NTL, et l'accepteur fournit des services d'échange pour échange.",
    buyin: 'Acheter',
    sell: 'Vendre',
    buyprice: "Prix d'achat",
    sellprice: 'Prix de vente',
    buynum: "Montant d'achat",
    sellnum: 'Montant de la vente',
    payamount: 'Paiement',
    getamount: 'Paiement',
    avabalance: 'Disponible',
    time: 'Date de transaction',
    tip: 'Remarquer',
    notice: 'Remarquer',
    notice1:
      "1. La zone d'échange de devises légale est une transaction d'actifs entre les utilisateurs et les accepteurs. Les fonds ne sont pas transférés vers une plate-forme et la plate-forme n'accepte pas la recharge / remise de RMB ；",
    notice2:
      "2. Les accepteurs de transactions en devises légales ont passé la certification en nom réel, offrant des marges de transaction, et les jetons sont hébergés par la plate-forme, vous pouvez donc être assuré qu'ils peuvent être convertis ；",
    notice3:
      "3. Le délai de service de l'accepteur est de 9 h 00 à 21 h 00 par jour. L'acceptation est effectuée dans les 30 minutes suivant l'acceptation de la commande et la transaction incomplète de deux heures est annulée ；",
    notice4:
      "4. Afin de prendre en charge les cartes bancaires dans la zone d'échange de devises légale, il est nécessaire de transférer des fonds en utilisant un compte que vous avez authentifié par votre vrai nom ；",
    notice5:
      "5. Afin de garantir la sécurité des fonds de transaction, la transaction en devise légale exige que les utilisateurs réussissent l'authentification par nom réel ；",
    payType: 'Payer le compte',
    receiveType: 'Recevoir un compte',
    moneyTips:
      'Le prix ci-dessus est pour référence uniquement. Veuillez vous référer au montant réel du règlement après la commande suivante.',
    verifyset: 'RealName / Asset Password',
    payset: 'Paramètres de paiement',
    trade: ' Échange',
    input50tips: 'Veuillez saisir un nombre compris entre 50 et 50 000',
    bank: 'Carte bancaire',
    alipay: 'Alipay',
    wechatpay: 'Wechat',
    payaccountset: 'Paramètres du compte de paiement',
    useselfaccount: "Veuillez vous assurer d'utiliser votre compte authentifié par votre nom réel.",
    orderSn: 'N ° de commande.',
    tradetime: "Date d'échange",
    direction: 'Direction',
    amount: 'Montant (USDT)',
    money: 'Total (CNY)',
    price: 'Prix (CNY)',
    status: 'Statut',
    operate: 'Exploiter',
    moredetail: 'Plus de détails',
  },
  cexchange: {
    use: 'Consommation',
    consume: 'Change',
    title: 'Conversion rapide',
    desc: 'Un clic,Profiter tous les jours',
    quantity: 'Quantité d’achat d’activité',
    inputtips1: 'Le nombre de coutume',
    choosecurrency: 'Choisissez une devise',
    maxtip: 'Rachat maximum ',
    mintip: 'échange minimum ',
    all: 'Tout',
    totalpay: 'Montant en devise payé',
    restricted: "Le total restreint aujourd'hui",
    currentprice: 'Prix actuel',
    nextprice: 'Prix du prochain numéro',
    confirmpay: 'Confirmer le paiement',
    assets: 'Solde:',
    loginFirst: 'Veuillez vous connecter',
    success: 'Félicitations, échange réussi!',
    tip: 'Conseils',
    confirm: 'Confirmer les conseils',
    confirmmsg: "Êtes-vous sûr d'échanger des BZB?",
    ok: "D'ACCORD",
    cancel: 'Annuler',
  },
  option: {
    title: "Contrat d'option",
    buyupreward: 'Acheter un pool de récompenses',
    buydownreward: 'Vendre un pool de récompenses',
    quantity: 'Montant du pari',
    myamount: 'Montant de mon pari',
    buyup: 'Augmenter les prix',
    buydown: 'Baisser les prix',
    history: "L'histoire",
    seriers: 'Non.',
    period: '',
    currentoption: 'Intervalle de temps',
    openprice: 'Prix Ouvert',
    currentprice: 'Prix courant',
    openprice1: 'Prix Ouvert',
    closeprice: 'Prix de clôture',
    opentime: 'Temps ouvert',
    closetime: 'La période de fermeture',
    progress: 'Le progrès',
    loginFirst: "S'il vous plait Connectez-vous d'abord!",
    selectAmount: 'Veuillez sélectionner votre montant',
    balancenotenough: 'Banlance ne suffit pas!',
    betsuccess: 'Félicitations！ Pari réussi！',
    noopening: 'Aucune ouverture maintenant!',
    col_createTime: 'Créer du temps',
    col_direction: 'Direction',
    col_result: 'Résultat',
    col_optionNo: 'Non.',
    col_betAmount: 'Montant du pari',
    col_rewardAmount: 'Montant de la récompense',
    col_fee: "Frais d'ouverture",
    col_winfee: 'Frais de récompense',
    win: 'Gagner',
    lose: 'Perdre',
    wait: 'Ouverture',
    avaliablebalance: 'Solde disponible',
    login: 'Veuillez vous connecter',
    kline: 'Reunión provisional',
  },
  otc: {
    payment_detail: 'Détails du mode de paiement',
    bind_payment: 'Lier le moyen de paiement',
    payment_placeholder: 'Veuillez sélectionner un mode de paiement',
    payment: 'Mode de paiement',
    ad: 'La publicité',
    buyin: 'Acheter',
    sellout: 'Vendre',
    merchant: 'Marchande',
    applymerchant: 'Appliquer le marchand',
    volume: 'Le volume',
    paymethod: 'Mode de paiement',
    amount: 'Montant',
    price_coin: 'Prix / Pièce',
    operate: 'Action',
    validate: "Veuillez d'abord vérifier",
    sell: 'vendre',
    buy: 'acheter',
    transaction: 'Transactions commerciales',
    buttontxt: 'Devenir marchand',
    title: 'Échange OTC',
    desc: 'Vente pratique, sûre et rapide de devises numériques',
    title1: 'Réglage dynamique',
    desc1: 'Fluctuation en temps réel en fonction du prix du marché',
    title2: 'Pas de frais',
    desc2:
      "Ce que vous voyez est ce que vous obtenez. Outre le prix de vente, il n'y a pas de frais de service pour la plateforme",
    title3: 'Transaction immédiate',
    desc3:
      "La mise en place de services de plateforme pour les commerçants, appariement intelligent, clôture de commande, pas besoin d'attendre le matchmaking",
    title4: 'Garantie de la plateforme',
    desc4:
      "Entreprise de certification de plateforme, la sécurité est garantie, service client 24h / 24 pour l'escorte de transaction",
    myad: {
      title: 'Mon annonce',
      post: 'Poster une annonce',
      alert:
        "【Astuce】 ： Lorsque le montant minimum des achats publicitaires plus les frais est supérieur au nombre d'annonces restant, l'annonce est automatiquement retirée de l'étagère.",
      no: 'non',
      type: 'type',
      sell: 'vendre',
      buy: 'acheter',
      limit: 'limite',
      remain: 'rester montant',
      coin: 'pièce',
      created: 'date de création',
      operate: 'action',
      errmsg: "Peut être édité et modifié une fois l'annonce arrêtée",
      update: 'Éditer',
      shelf: 'étagère',
      dropoff: 'déposer',
      delete: 'effacer',
    },
    myorder: 'Ma commande',
    chatline: {
      status_1: "L'acheteur n'a pas payé et a attendu que l'acheteur paie！",
      status_2: "L'acheteur a payé et attend que le vendeur libère！",
      status_3: 'Commande terminée la transaction！',
      status_4: "La commande fait l'objet d'un appel！",
      status_5: 'Commande annulée!',
      loadmore: 'Charger plus',
      warning:
        'Alertes antifraude: Récemment, des fraudeurs ont utilisé à plusieurs reprises des informations de virement bancaire et de faux identifiants de paiement pour fraude. Veillez donc à vérifier votre propre numéro de compte de paiement. Assurez la sécurité des fonds de transfert et évitez le risque de les cartes bancaires sont gelées！ ',
      contenttip: 'Veuillez saisir le contenu du chat Entrez la clé à envoyer',
      contentmsg: 'Le message ne peut pas être vide',
    },
    chat: {
      seller: 'Vendeur',
      buyer: 'Acheteur',
      exchangeamount: "Montant de l'échange",
      operatetip: 'Actionnez la pointe',
      operatetip_1:
        "Veuillez effectuer le paiement conformément au compte donné par l'autre partie dans le délai imparti et cliquez sur cette page.",
      finishpayment: 'paiement terminé',
      operatetip_1_1:
        'Veuillez noter dans les commentaires lorsque vous transférez le bon numéro de référence de paiement',
      operatetip_1_2:
        'Après réception du paiement, le vendeur confirmera le paiement sur le site Web. Le système enverra automatiquement les actifs numériques que vous avez achetés sur votre compte. Veuillez noter que',
      note: 'Remarque',
      notetip:
        "Veuillez ne pas utiliser d'autres logiciels de chat pour communiquer entre eux et n'accepter aucun document, pièce jointe d'e-mail, etc. qui vous a été envoyé par la direction. Tous les liens de communication sont remplis dans la fenêtre de discussion sur cette page.",
      operatetip_2_1:
        'Les actifs numériques que vous avez vendus ont été soumis à la plateforme pour hébergement et gel. Vous avez confirmé votre paiement, cliquez sur',
      operatetip_2_2:
        "S'il vous plaît ne croyez aucune raison pour exhorter la devise à être libérée, confirmez la réception de l'argent et libérez les actifs numériques pour éviter toute perte！",
      operatetip_2_3:
        "Après avoir reçu le court message sur le compte, assurez-vous de vous connecter à la banque en ligne ou à la banque mobile pour confirmer si le paiement est comptabilisé, afin d'éviter la fausse libération d'actifs numériques en raison de la réception de messages frauduleux！",
      confirmrelease: 'Confirmer la libération',
      paydigital: 'Payer des actifs numériques',
      orderstatus: 'Statut de la commande',
      orderstatus_1: 'paiement terminé',
      orderstatus_2: "Ordonner l'appel",
      orderstatus_3: 'Confirmer la libération',
      orderstatus_4: 'annuler la transaction',
      orderstatus_5: "Ordonner l'appel",
      order: 'Ordre',
      and: 'et',
      transition: 'échange',
      transprice: 'Prix de négociation',
      transnum: 'Numéro de transaction',
      transmoney: 'Montant du trading',
      tip1: "L'utilisateur n'a pas encore ajouté le numéro de carte bancaire",
      tip2: "L'utilisateur n'a pas ajouté le compte Alipay pour le moment",
      tip3: "L'utilisateur n'a pas encore ajouté le compte WeChat",
      zfb: 'Alipay',
      wx: 'WeChat',
      qrcode: 'QR Code',
      msg1: "Êtes-vous sûr d'avoir payé?",
      msg2: "Les paiements ne sont pas remboursables! Êtes-vous sûr d'annuler votre commande?",
      msg3: "【Répéter】 ： Les paiements ne sont pas remboursables! Êtes-vous sûr d'annuler votre commande?",
      msg4: 'Payé, non reçu',
      msg5: 'Déjà payé, non reçu',
      tip: 'Pointe',
      comptype: 'Type de réclamation',
      compremark: 'Note de réclamation',
      willcomp: 'Je veux me plaindre',
      msg6: 'Confirmez-vous la libération des devises?',
      result_1: 'en attente de paiement',
      result_2: 'En attente de libération',
      result_3: 'Terminé',
      result_4: 'Attrayant',
      result_5: 'Annulé',
      msg7: 'Mot de passe du fonds',
      msg7tip: 'veuillez saisir le mot de passe du fonds',
    },
    checkuser: {
      emaildone: 'Email certifié',
      emailundo: 'E-mail non autorisé',
      teldone: 'Certifié Telno',
      telundo: 'Telno non autorisé',
      idcarddone: 'Certifié IDCard',
      idcardundo: 'IDCard non autorisée',
      language: 'Langue',
      languagetext1: 'English',
      languagetext: 'Chinois',
      registtime: "Heure d'enregistrement",
      exchangetimes: 'Transactions cumulées',
      exchangeinfo: 'Informations commerciales',
      tablabel1: 'Vendre en ligne',
      tablabel2: 'Acheter en ligne',
      col_symbol: 'Pièce',
      col_paymode: 'Mode de paiement',
      col_num: 'Montant',
      col_price: 'Prix',
      col_created: 'Temps de libération',
      col_operate: 'Exploiter',
      operatemsg: "Veuillez d'abord effectuer l'authentification du nom réel",
      buyin: 'Acheter',
      sellout: 'Vendu',
    },
    tradecenter: {
      postad: 'Poster une annonce',
      exchange: 'Transaction GCC',
      buyin: 'Je veux acheter',
      sellout: 'Je veux me vendre',
    },
    tradeinfo: {
      emaildone: 'Email certifié',
      emailundo: 'E-mail non autorisé',
      teldone: 'Certifié Telno',
      telundo: 'Telno non autorisé',
      idcarddone: 'Certifié IDCard',
      idcardundo: 'IDCard non autorisée',
      exchangetimes: "Horaires d'échange",
      price: 'Prix',
      num: 'Montant',
      paymethod: 'PayMethod',
      exchangelimitamount: "Limite d'échange",
      location: 'Emplacement',
      location_text: 'Chine',
      exchangeperiod: "Période d'échange",
      minute: 'min',
      amounttip: 'Veuillez saisir le montant',
      numtip: 'Veuillez entrer le numéro',
      remarktip: 'Dites-lui votre demande',
      remarktitle: 'Remarques Horizon',
      exchangetitle: 'Informations commerciales',
      exchange_tip1:
        "Une fois que vous avez lancé la demande de transaction, la monnaie numérique est verrouillée dans l'hébergement et protégée par la plateforme. Si vous êtes un vendeur, après avoir lancé une demande de transaction, vous pouvez recharger et attendre que l'acheteur paie. Les acheteurs paient dans le délai de paiement. Après avoir reçu le paiement, vous devez libérer la monnaie numérique dont vous avez la garde. ",
      exchange_tip2:
        "À lire avant de négocier 《Conditions d'utilisation de Platform Network》 et FAQ, guides de trading et autres documents d'aide.",
      exchange_tip3:
        "Attention au menteur! Avant la transaction, veuillez vérifier la note reçue par l'utilisateur et prêter plus d'attention au compte nouvellement créé.",
      exchange_tip4:
        "Veuillez noter ， L'arrondi et les fluctuations de prix peuvent affecter le montant de la monnaie numérique qui est finalement échangé. Le montant fixe que vous saisissez détermine le montant final, et le montant de la monnaie numérique sera calculé à partir du taux de change instantané en même temps que le demande est émise. ",
      exchange_tip5:
        "Les services d'hébergement protègent à la fois les acheteurs et les vendeurs des transactions en ligne. En cas de litige, nous évaluerons toutes les informations fournies et communiquerons la monnaie numérique hébergée à son propriétaire légal.",
      warning1: "Saisissez jusqu'à 2 décimales",
      warning2: 'Le montant de la commande est',
      warning3: "Entrez jusqu'à 8 décimales",
      warning4: 'La quantité commandée est',
      confirmbuyin: "Confirmer l'achat",
      confirmsellout: 'Confirmer la vente',
      buyin: 'Acheter',
      sellout: 'Vendu',
      warning5: 'Veuillez remplir la commande selon vos besoins',
    },
    publishad: {
      createad: 'Créer un accord publicitaire',
      msg1: "Si vous tradez souvent, vous pouvez créer votre propre annonce de trading. Si vous ne négociez qu'occasionnellement, nous vous recommandons d'effectuer une recherche directement",
      msg2: 'Créer une annonce commerciale est',
      msg3: 'Gratuit',
      msg4: 'Si vous souhaitez modifier directement les annonces créées, veuillez cocher',
      tradead: 'Publicité commerciale',
      myad: 'Mon annonce',
      iwant: 'Je voudrais',
      sellonline: 'vendre en ligne',
      buyonline: 'acheter en ligne',
      exchangecoin: 'Échange de pièces',
      country: 'Pays',
      currency: 'Pièce',
      openfixedprice: 'Prix fixe ouvert',
      open: 'Ouvert',
      close: 'Fermer',
      usetip:
        "Lorsqu'il est activé, le prix de votre devise ne fluctuera pas avec le marché et le prix ne changera pas.",
      premiseprice: 'Premium',
      premisepricetip: 'Veuillez définir votre prime',
      fixedprice: 'prix fixe',
      fixedpricetip: "Veuillez saisir votre prix d'échange",
      marketprice: 'Prix de référence du marché',
      marketpricetip: 'La prime correspond au pourcentage supérieur au prix actuel du marché',
      exchangeprice: "Prix d'échange",
      formual: 'Formule de tarification',
      num: 'Montant',
      num_text1: 'Veuillez entrer ce que vous voulez',
      num_text2: 'num',
      exchangeperiod: 'Période de transaction',
      exchangeperiod_text1: 'Veuillez saisir votre date limite de négociation',
      minute: 'min',
      tip1: "La durée pendant laquelle l'acheteur peut accepter les transactions, veuillez saisir un entier",
      tip2: '【Astuce】 Peut être lié au centre personnel / Ajouter un mode de paiement',
      tip3: 'Veuillez saisir le montant minimum de votre transaction',
      tip4: 'Veuillez saisir le montant maximal de votre transaction',
      tip5: "Vous pouvez remplir vos exigences particulières dans les informations relatives aux remarques, telles que: les exigences de l'acheteur, le temps en ligne, etc.",
      paymode: 'Mode de paiement',
      minlimit: 'Montant minimum de la transaction',
      maxlimit: 'Montant maximal de la transaction',
      remark: 'Remarques',
      openautoreply: 'Ouvrir la réponse automatique',
      msg5: "Lorsque cette option est activée, lorsque l'utilisateur vous lance une transaction via cette annonce, le système envoie automatiquement la phrase de réponse automatique que vous avez sélectionnée à l'autre partie.",
      autoreply: 'Réponse automatique',
      autoreplytip:
        "Après réception de la commande, les informations sont automatiquement renvoyées à l'acheteur, par exemple: mode de paiement, numéro de compte de collecte, etc.",
      fundpwd: 'Mot de passe du fonds',
      fundpwdtip: 'Veuillez saisir votre mot de passe pour les fonds',
      submit: 'Soumettre',
      warning1: 'Veuillez saisir le numéro correct',
      warning2: 'La valeur de dépassement est de 0 à 20',
      warning3: 'Veuillez saisir le montant maximum de votre transaction!',
      warning4: 'Veuillez saisir un entier',
      warning5:
        'Le montant maximum de la transaction doit être supérieur au montant minimum de la transaction!',
      warning6:
        'Le montant maximal de la transaction ne peut pas dépasser le montant total de votre vente',
      warning7: 'Veuillez saisir le montant minimum de votre transaction!',
      warning8: 'Le montant minimum de la transaction doit être supérieur ou égal à 100!',
      warning9:
        'Le montant minimum de la transaction doit être inférieur au montant maximum de la transaction',
      sellout: 'Vendre',
      buyin: 'Acheter',
      inputtip1: 'Veuillez saisir la devise',
      inputtip2: 'Veuillez saisir la bonne option',
      inputtip3: 'La valeur de dépassement est 0-20 et ne peut pas être 0',
      inputtip4: 'Veuillez saisir le prix fixe correct',
      inputtip5:
        'Veuillez saisir le nombre correct et le nombre maximum de transactions ne dépasse pas 100',
      inputtip6: 'Veuillez saisir la date limite de négociation correcte',
      inputtip7: 'Veuillez sélectionner la méthode de transaction',
      inputtip8: 'Veuillez saisir le mot de passe des fonds',
      zfb: 'Alipay',
      wx: 'Wechat',
      unionpay: 'BankCard',
      submit_failure: 'Échec!',
      submittip1: 'Veuillez procéder à une série de certifications telles que les vrais noms',
      submittip2:
        'Veuillez effectuer une série de certifications telles que les téléphones portables',
      submittip3:
        'Veuillez procéder avec une série de certifications telles que des mots de passe en majuscules',
      submittip4: 'Veuillez lier au moins un mode de paiement',
    },
    index: {
      title: 'Bonne recommandation publicitaire',
      exchangetimes: 'Temps de transaction',
      exchangeprice: 'Prix de transaction',
      exchangelimit: 'Limite de transaction',
      paymode: 'Mode de paiement',
      buy: 'acheter',
      sell: 'vendre',
      viewmore: 'Plus',
      bot1: 'Sûr et fiable',
      bot1_tip:
        "Plus de 10 ans d'expérience dans l'équipe de contrôle des risques financiers  nSystème de politique de sécurité personnalisable",
      bot2: 'Rapide et facile',
      bot2_tip:
        "Prise en charge du mode de transaction gratuit pour les utilisateurs peer-to-peer  nTypes de canaux d'échange d'argent",
      bot3: 'Pleine devise',
      bot3_tip:
        "Sélection des principales devises de transaction d'actifs numériques  nExpérience de trading multi-actifs",
      ibuy: 'Je veux acheter',
      isell: 'Je veux vendre',
    },
  },
  activity: {
    all: 'Tout',
    prepare: 'À venir',
    ongoing: 'En cours',
    distributing: 'Distribuer',
    completed: 'Terminé',
    progress: 'Le progrès',
    totalsupply: 'Offre totale',
    starttime: 'Date de début',
    endtime: 'Date de fin',
    viewdetail: 'Détail',
    attend: 'Assister',
    tokendistribute: 'Distribution de jetons',
    baseinfo: "Infos sur l'activité",
    status: 'Statut',
    activitytype: "Type d'activité",
    activitytype0: 'Inconnu',
    activitytype1: 'Liste (FOF)',
    activitytype2: 'Liste (AVA)',
    activitytype3: 'HolderDivide',
    activitytype4: 'FreeBuy',
    activitytype5: 'MiningBuy',
    activitytype6: 'Fermé à clé',
    ruledetail: 'À propos de la règle',
    publishprice: 'Prix de publication',
    activitycoin: "Symbole de pièce d'activité",
    accpetcoin: 'Accepter le symbole de pièce',
    holdcoin: 'Tenir le symbole de la pièce',
    limittimes: 'Temps limite personnel',
    limitamount: 'Montant limite personnel',
    unlimited: 'Illimité',
    alreadyamount: 'Montant déjà vendu',
    leftamount: 'Montant restant',
    attention: 'Attention',
    attentiontxt1:
      "1 、 Les actifs seront gelés après leur soumission pour participer à des activités de type [partitionnement d'entrepôt] et [abonnement gratuit] jusqu'à la fin de la décongélation.",
    attentiontxt2:
      "2 、 Les utilisateurs ne peuvent pas retirer leur demande de participation après avoir participé aux activités du type 'Holder Divide' et 'Fress Buy' ",
    attentiontxt3:
      "3 、 Si l'activité est annulée en raison de la partie au projet et d'autres facteurs de force majeure, l'itinéraire initial est restitué aux avoirs gelés.",
    attentiontxt4:
      "* Le droit d'interprétation finale de cette activité appartient à la propriété officielle de NTL.",
    inputamount: "Montant d'entrée",
    inputholdamount: "Quantité de verrouillage d'entrée",
    mybalance: 'Solde disponible',
    holdtips: "[HolderDivide] nécessite un verrouillage jusqu'à la fin de l'activité.",
    pleaseinputamount: 'Veuillez saisir le montant!',
    pleaseinputholdamount: 'Veuillez saisir le montant de la retenue!',
    commitfailed: 'Échec de la validation！',
    minlimitamountfailed:
      "La quantité d'échange ne doit pas être inférieure au montant minimum minimum d'échange.！",
    maxlimitamountfailed:
      "Le montant de l'échange ne peut être supérieur au montant maximal d'achat.！",
    limittimesfailed: "Vous avez participé à plus que le nombre maximum d'achats individuels.！",
    balancenotenough: "L'équilibre ne suffit pas！",
    headertitledesc:
      'Laboratoires ouverts pour une coopération gagnant-gagnant entre investisseurs, projecteurs et échanges',
    currentdivided: 'Ma position actuelle sera',
    leveloneCount: 'Nombre limite de niveau un',
    submit: 'Soumettre',
    tipsmobile: 'Veuillez utiliser le site Web du PC （ntlex.com）',
    tipsmobile1: 'Vous pouvez accéder au site Web du PC pour participer à cette activité.',
    intvalue: 'Veuillez saisir la valeur int',
    inputminingamount: "Nombre d'achats d'entrée",
    moreactivity: "Plus d'activités",
    releaseType: 'Type de version',
    releaseType0: 'Libération égale',
    releaseType1: 'Libération isométrique',
    lock: 'Fermer à clé ',
    releaseDetail: 'Détails de la version',
    lockday: ' Journées',
    lockweek: ' Semaines',
    lockmonth: ' Mois',
    lockyear: ' Ans',
    releasePercent: 'Pourcentage de libération',
    lockFee: 'Frais de verrouillage',
    releaseTimes: 'Heures de sortie',
    times: 'fois',
  },
  invite: {
    inviteLoginName: 'Connectez - vous en tant que partenaire',
    chengwei: 'Possibilité maximale de retour à vie',
    pthhr: 'Devenir partenaire de la plateforme',
    partnerText:
      "Inviter les amis à s'inscrire et à s'authentifier avec leur vrai nom pour profiter des bonus de la plateforme",
    myinvitelink: 'Lien de promotion',
    copy: 'Copie',
    copyed: 'Copié',
    mylevelone: 'Amis de niveau un',
    myleveltwo: 'Amis de niveau deux',
    mycommission: 'Revenus de commissions (USDT)',
    extrareward: 'Récompenses supplémentaires',
    partnerlevel: 'Niveau partenariat',
    ruledetail: 'Détails de la règle',
    ruleprofile1:
      '[Le partenaire de promotion] représente la proportion la plus élevée de retour de commission en ligne et la plus longue période de retour de commission (commission maximale à vie). Les promoteurs qui font les efforts correspondants peuvent devenir de véritables« partenaires »de la plateforme et profiter du dividende de la croissance avec la plateforme de trading NTL . Les règles détaillées sont les suivantes: ',
    ruleprofile2: '',
    ruleprofile3: '',
    ruleprofile4: '',
    ruletext1:
      "1 、 Afin de prêcher le concept d'actifs numériques et d'élargir la taille des utilisateurs, NTL a lancé le programme 'Promotion Partner ', qui est efficace depuis longtemps.",
    ruletext2:
      "2 、 Inviter des amis peut être divisé en deux niveaux. Si A invite B, alors B est l'ami de premier niveau de A. Si B invite C, alors C appartient à l'ami de premier niveau de B et aussi à l'ami de deuxième niveau de A. ",
    ruletext3:
      "3 、 Lors de la promotion de l'inscription d'amis, les amis de premier niveau des invités ne peuvent être les amis de premier niveau des invités que par les liens fournis par les invités ou en entrant manuellement les codes d'invitation des invités.",
    ruletext4:
      '4 、 L’incitation à la remise prend effet lorsque la personne invitée termine son inscription via le code d’invitation de l’invité.',
    ruletext5:
      '5 、 La durée de la remise est de N mois à compter de la fin de l’enregistrement de la personne invitée. Selon le niveau, le pourcentage de remise peut être apprécié.',
    ruletext6:
      "6 、 La promotion des actifs de commission correspond aux frais de transaction de la devise d'ami de niveau inférieur, qui correspond aux trois devises de base du marché, à savoir l'USDT, le BTC et l'ETH.",
    ruletext7:
      "7 、 La proportion et la durée de la commission de promotion sont positivement corrélées avec le nombre d'amis de premier niveau. Plus le nombre de promotions est élevé, plus la proportion de commission agréable est élevée. La promotion spécifique du ratio de remise de commission est la suivante ：",
    ruletext8:
      '8 、 TOP10 ou TOP100 recevront de temps à autre des primes supplémentaires de MKWORLDS.',
    ruletext9:
      "9 、 Si d'autres activités sont en conflit avec les activités du partenaire de promotion, les partenaires devront comprendre s'ils doivent changer temporairement après consultation.",
    ruletext10:
      "10 envoy Les partenaires de niveau d'envoyé L4 (Xunfu), L5 (Taishou) et L6 (Jiedushi) ont droit à des bonus de 5%, 10% et 15% du total des retours annuels de la Commission, respectivement.",
    ruletext11: "11 、 Le droit d'interprétation finale de cette activité appartient à NTL.",
    ruleexampletitle: 'Par exemple:',
    ruleexamplecontent1:
      "Si l'utilisateur Xiaoyan a invité 100 amis de première classe, les amis de première classe de TA ont invité cinq amis de seconde classe, alors Xiaoyan avait 100 amis de première classe et 500 amis de seconde classe. Si la personne moyenne échange 3000 yuans par jour, Le revenu mensuel de Xiaoyan est d'environ (100 * 3000 * 0,001 * 30% + 500 * 3000 * 0,001 * 10%) * 30 = 7200 / mois. ",
    ruleexamplecontent2:
      "Si l'utilisateur Xiaoyan a invité 1000 amis de première classe, TA amis de première classe a invité 5 amis de deuxième classe, Xiaoyan avait 1000 amis de première classe et 5000 amis de deuxième classe. Si la personne moyenne échange 3000 yuans par jour, le mensuel de Xiaoyan le revenu est d'environ (1000 * 3000 * 0,001 * 50% + 5000 * 3000 * 0,001 * 20%) * 30 = 135000 / mois. ",
    lastupdate: 'Dernière mise à jour dans',
    laststastic: 'Last stastic in',
    level: 'Niveau',
    lv1: 'Lizheng',
    lv2: 'Xianling',
    lv3: 'Zhifu',
    lv4: 'Xunfu',
    lv5: 'Taishou',
    lv6: 'Jiedushi',
    levelonecount: 'Nombre de niveau un',
    levelonecommission: 'Rapport de retour / temps de retour de niveau un',
    leveltwocommission: 'Rapport de retour / temps de retour de niveau deux',
    partnerdivide: 'Dividende partenaire',
    day: 'ciel',
    alllife: 'Durée de vie',
    totalcommissionrank: 'Promotion de la Commission totale',
    rank: 'Non.',
    userid: "Identifiant d'utilisateur",
    rankday: '(Journée)',
    rankweek: '(La semaine)',
    rankmonth: '(Mois)',
    rankall: '(Tout)',
    promotioncount: 'Nombre de promotions',
    commissionusdt: 'Commission (USDT)',
    ranktip1:
      "Le nombre d'invitations correspond au nombre d'amis de première classe. Cette liste classe le montant total des commissions de grande à petite.",
    ranktip2:
      "Le nombre d'invitations correspond au nombre d'amis de première classe. La liste est classée en fonction du nombre d'amis de première classe invités.",
    thanks: 'Merci de soutenir NTL！',
    headertip:
      'Les données ci-dessus ne sont pas mises à jour en temps réel. Les statistiques du système et se mettent à jour toutes les 24H.',
    ptools: 'Outils de promotion',
    pt_title: 'Carte cadeau crypto-monnaie',
    pt_desc:
      "C'est une surprise du futur, d'envoyer des amis, des parents, des clients, des partenaires.",
    pt_more: 'De nouveaux outils sont à venir',
    pt_tips:
      "Si vous avez une bonne idée, envoyez un e-mail à promotion@NTLEX.COM, avec une récompense après l'adoption.！",
    pt_card_amount: 'Montant de la carte',
    pt_card_deadline: 'Date limite',
    pt_card_noend: 'Indéfini',
    pt_card_btn: 'Obtenez 30 cartes gratuitement',
    pt_card_btn1: 'Les partenaires de promotion obtiennent gratuitement', // 新增
    pt_card_btn2: '', // 新增
    pt_card_btn_login: "S'il vous plait Connectez-vous d'abord",
    pt_card_rule: 'Détails de la règle',
    pt_card_summary:
      'La carte-cadeau en monnaie numérique est un outil promotionnel développé pour permettre aux partenaires promotionnels de mieux inviter des amis hors ligne. Lorsque les utilisateurs échangent des cartes-cadeaux, ils deviennent automatiquement les amis hors ligne des partenaires promotionnels.',
    pt_card_rule1:
      "1. Les cartes-cadeaux gratuites sont limitées à 30 cartes par utilisateur. Si d'autres cartes-cadeaux doivent être émises, les utilisateurs doivent payer pour la personnalisation, ce qui peut personnaliser le nombre de cartes, le LOGO, les instructions, etc. Pour des exigences personnalisées, veuillez envoyer un courriel à",
    pt_card_rule2:
      "2. Les cartes-cadeaux gratuites sont limitées à un exemplaire par utilisateur. Les cartes-cadeaux gratuites émises par le gouvernement NTL sont limitées à une pour chaque utilisateur. Même si différents utilisateurs reçoivent des cartes-cadeaux gratuites avec différents codes d'échange, une seule peut être échangée. Les cartes cadeaux personnalisées ne sont pas soumises à cette restriction. ",
    pt_card_rule3:
      "3. Avant que l'utilisateur n'échange la carte-cadeau, s'il n'y a pas d'invitation (c'est-à-dire que le code d'invitation n'a pas été saisi au moment de l'enregistrement du compte), il sera automatiquement associé à l'ami de premier niveau du émetteur de la carte. Si A ne saisit pas de code d'invitation lors de la création d'un compte, alors A n'appartient à aucun ami de premier ou de deuxième niveau, mais lorsque A est converti en amis de premier niveau de B via la carte-cadeau émise par B, A devient automatiquement les amis de premier niveau de B. ",
    pt_card_rule4:
      "4. Afin d'éviter le brossage, la valeur comptable des cartes-cadeaux n'est pas payée en temps réel. Elle sera gelée pendant 180 jours après la collecte et libérée automatiquement dans le solde du compte utilisateur après 180 jours.",
    pt_card_rule5:
      "5. Lors de la réception de cartes-cadeaux gratuites, nous devons compléter la certification du nom réel. Lors de la conversion, nous pouvons les obtenir sans avoir obtenu la certification du nom réel. Cela permet aux promoteurs d'obtenir plus rapidement des amis de niveau inférieur.",
    pt_card_rule6:
      "6. Le droit d'interprétation finale des cartes-cadeaux gratuites appartient à ntlex.com.",
    pt_card_day: 'Journées',
    pt_card_title_tips: 'Bourse de promotion gratuite de 2000 CNY',
    pt_card_title_tips1: 'bénéficiaires',
    pt_card_title_tips2: 'Promotion booster kim',
    pt_card_receivew_success:
      'Félicitations! Collecte réussie des cartes-cadeaux de promotion des partenaires! Veuillez vous rendre dans le Centre personnel -> Centre des cartes et bons.',
    usepromotion: 'Utiliser du matériel promotionnel',
    saveimage: "Enregistrer l'image",
    imagetips:
      "Si vous ne parvenez pas à télécharger correctement les images, veuillez les télécharger à l'aide de l'outil de capture d'écran!",
    pt_invite_title: "Brochure d'inscription à l'invitation",
    pt_invite_desc:
      "Devenez automatiquement des amis subordonnés grâce à l'enregistrement de code bidimensionnel, adapté au transfert dans divers groupes ou forums.",
    colum_text0: 'Rang',
    colum_text1: 'Membre',
    colum_text2: 'Promotion',
    colum_text3: 'Commission (USDT)',
    colum_text4: 'Récompense supplémentaire',
    context_title: "Code d'échange exclusif pour les partenaires de promotion",
    context_title1: 'Scannez pour en savoir plus',
    context_title2: "Mon code d'invitation",
    context_title3: "Image d'invitation",
  },
  uc: {
    retrieveprivate: {
      findText: 'Récupérer la clé privée du compte',
      findText2: 'Compte recréé clé privée',

      inputFindtext: 'Saisissez la boîte aux lettres liée au compte',
      continue: 'Continue.',
    },
    verify: "Terminer KYC d'abord",
    login: {
      welcomelogintxt: 'Bienvenue à ntl!',
      welcomelogintxt2: "Si vous n'avez pas encore de compte",
      welcomelogintxt3: 'Vous pouvez cliquer ici',
      welcomelogintxt4: 'Numéro de compte enregistré',
      welcomelogintxt5: 'Compte de connexion',
      welcomelogintxt6: 'Si vous avez déjà un compte',
      welcomelogintxt7: 'Commencez un nouveau voyage de trading',
      inputPrivate: 'Veuillez saisir la clé privée du compte...',
      forgetPrivateTxt: 'Tu as oublié ta clé privée?',
      phoneEmail: 'Connexion au téléphone ou à la boîte aux lettres',
      anonymousLogin: 'Connexion anonyme',
      noaccount: 'Pas de compte?',
      register: "S'inscrire",
      login: "S'identifier",
      welcomelogin: 'Bienvenue',
      usertip: "Entrez le numéro de téléphone ou l'adresse e-mail",
      pwdtip: 'Entrer le mot de passe',
      validatecodeload: 'Chargement du code de vérification',
      validatemsg: "Veuillez d'abord terminer la vérification",
      forget: 'Mot de passe oublié?',
      loginvalidate: 'Veuillez saisir votre adresse e-mail ou votre numéro de téléphone',
      pwdvalidate1: 'Veuillez saisir le mot de passe',
      pwdvalidate2: "La longueur du mot de passe n'est pas inférieure à six",
      success: 'Succès',
      goregister: 'Aller à l’enregistrement',
      getlostpwd: 'Mot de passe oublié',
    },
    forget: {
      title: 'Trouver le mot de passe',
      hasaccount: 'Avoir un compte？ Pour vous connecter',
      login: "S'identifier",
      sendcode: 'Envoyer',
      newpwd: 'Entrez un nouveau mot de passe',
      confirmpwd: 'Saisissez à nouveau le nouveau mot de passe',
      save: 'Soumettre',
      pwdvalidate1: 'Entrez le mot de passe de confirmation',
      pwdvalidate2: "Le mot de passe n'est pas le même!",
      resettelpwd: 'Réinitialiser le mot de passe tél',
      resetemailpwd: "Réinitialiser le mot de passe de l'e-mail",
      newpwdtip: 'Entrez un nouveau mot de passe',
      pwdvalidate3: "La longueur du mot de passe n'est pas inférieure à six",
      telno: 'Numéro de téléphone',
      smscode: 'Code de vérification SMS',
      teltip: 'Entrez tel',
      smscodetip: 'Entrez le code de vérification par SMS',
      email: 'Email',
      password: 'Les mots de passe',
      NoId: 'Pas encore de compte',
      emailcode: "Code de vérification de l'e-mail",
      emailtip: 'Entrez votre e-mail',
      emailcodetip: "Entrez le code de vérification de l'e-mail",
      resetpwdsuccess: 'Réinitialiser le mot de passe avec succès',
      smswarn: 'Veuillez vérifier les SMS',
      bangding: 'Liaison par balayage de code',
      googleAuth: 'GoogleAuth',
      pleaseGoogleAuth: 'Liaison GoogleAuth',
      bindGoogleAuth: 'Lié GoogleAuth',
      jcbind: 'Débloquer',
    },
    finance: {
      center: 'Centre financier',
      personalassets: 'Actifs en devises',
      swapassets: 'Swap Assets',
      billdetail: 'Détail de la facture',
      charge: 'Dépôt',
      pickup: 'Retrait',
      tradetail: 'Trade Mining',
      paydividends: 'Payer des dividendes',
      invitingmining: 'Inviting Mining Awards',
      money: {
        cointype: 'Pièce',
        balance: 'Équilibre',
        frozen: 'Solde gelé',
        operate: 'Action',
        charge: 'Dépôt',
        pickup: 'Retrait',
        onkeytrans: 'Trans',
        getaddress: "Obtenir l'adresse",
        resetsuccess: 'Réinitialisation réussie',
        match: 'Rencontre',
        matchtip1: 'Montant GCX de correspondance disponible',
        matchtip2: 'Saisir le montant correspondant',
        matcherr1: 'Veuillez saisir une quantité valide!',
        matcherr2: 'Dépasse le nombre maximum de correspondances!',
        matchsuccess: 'Match Success!',
        needreleased: 'Actifs à libérer',
        totalassets: 'Valeur totale estimée des actifs ：',
      },
      swap: {
        totalassets: 'Valeur totale estimée des actifs ：',
        swap: 'Swap',
        swaptype: 'SWAP',
        swapassets: 'Capitaux propres du compte',
        avabalance: 'Marge Avali',
        usebalance: 'Marge utilisée',
        frozenbalance: 'Marge gelée',
        profitandloss: 'Pl non réalisé',
        transfor: 'Transfert',
        inputtransferamount: 'Montant du transfert',
        all: 'Tout',
        currencyaccount: 'Compte Spot',
        swapaccount: "Compte d'échange perpétuel",
        clickchange: 'Cliquez pour changer de direction',
        avaamount: 'Disponible',
        pleaseselectwallet: 'Veuillez choisir un poing de portefeuille de transfert.',
        pleaseinputamount: 'Veuillez saisir le montant du transfert',
        oktransfer: 'Transférer maintenant',
      },
      trade: {
        accumulative_return: 'Les frais miniers ont été remboursés (BHB):',
        accumulat_return: 'Les frais miniers doivent être remboursés (BHB):',
        start_end: 'Début Fin',
        account_date: 'Il est temps de recevoir le capital',
        to: 'À',
        operatetype: "Type d'action",
        search: 'Chercher',
        charge: 'Charge',
        pickup: 'Ramasser',
        transaccount: 'Transfert',
        exchange: 'Échange',
        otcbuy: 'Achat OTC',
        otcsell: 'Vente OTC',
        activityaward: "Prix de l'activité",
        promotionaward: 'Prix de promotion',
        dividend: 'Dividende',
        vote: 'Voter',
        handrecharge: 'Recharge artificielle',
        match: 'Rencontre',
        activitybuy: "Achat d'activité",
        ctcbuy: 'CTC-Buy',
        ctcsell: 'CTC-Sell',
        chargetime: 'temps de génération de la commande',
        type: 'Type',
        num: 'Montant',
        status: 'Statut',
        finish: 'Fini',
        fee: 'Remboursement des frais miniers',
        transactionTime: 'Temps de négociation',
        symbol: 'Paire de pièces',
        direction: 'Direction',
        price: 'Prix',
        entrustment: 'Confiance',
        havedeal: "J'ai fait un accord",
        poundageAmount: 'Frais de service',
        exchangeOrderId: "L'ID de la commande",
        mineAmount: 'Creusez une devise (BHB)',
        buy: 'ACHETER',
        sell: 'VENDRE',
        limit: 'LIMIT',
        market: 'MARCHÉ',
        clear: 'État clair',
        turnover: "Chiffre d'affaires",
      },
      inviting: {
        accumulative_return:
          'Des récompenses minières invitantes ont été retournées et accumulées (BHB):',
        accumulat_return: 'Inviter les récompenses minières à rendre (BHB):',
        account_date: 'Il est temps de recevoir le capital',
        start_end: 'Début Fin',
        to: 'À',
        operatetype: "Type d'action",
        search: 'Chercher',
        charge: 'Charge',
        pickup: 'Ramasser',
        transaccount: 'Transfert',
        exchange: 'Échange',
        otcbuy: 'Achat OTC',
        otcsell: 'Vente OTC',
        activityaward: "Prix de l'activité",
        promotionaward: 'Prix de promotion',
        dividend: 'Dividende',
        vote: 'Voter',
        handrecharge: 'Recharge artificielle',
        match: 'Rencontre',
        chargetime: 'temps de génération de la commande',
        type: 'Type',
        num: 'Montant',
        status: 'Statut',
        finish: 'Fini',
        fee: 'Frais',
        symbol: 'Symbole de la pièce',
        refereename: "Nom de l'arbitre",
        referetel: "Numéro de téléphone portable de l'arbitre",
        invitingawards: 'Inviting Mining Awards (BHB)',
        refere: 'Arbitre',
        refereinput: 'Veuillez saisir le nom / numéro de téléphone portable',
      },
      paydividende: {
        money_holding: "Le partage d'argent a été retourné et accumulé (ETH):",
        money_hold: 'Payez des dividendes pour retourner (ETH):',
        paydividends: 'Payer des dividendes (ETH)',
        account_date: 'Il est temps de recevoir le capital',
        datehodld: "Date de détention de l'argent",
        start_end: 'Début Fin',
        to: 'À',
        operatetype: "Type d'action",
        search: 'Chercher',
        charge: 'Charge',
        pickup: 'Ramasser',
        transaccount: 'Transfert',
        exchange: 'Échange',
        otcbuy: 'Achat OTC',
        otcsell: 'Vente OTC',
        activityaward: "Prix de l'activité",
        promotionaward: 'Prix de promotion',
        dividend: 'Dividende',
        vote: 'Voter',
        handrecharge: 'Recharge artificielle',
        match: 'Rencontre',
        chargetime: 'Temps de charge',
        type: 'Type',
        num: 'Montant',
        status: 'Statut',
        finish: 'Fini',
        fee: 'Frais',
        symbol: 'Symbole de la pièce',
      },
      second: {
        secondaccount: 'Deuxième compte de contrat',
        swap: ' Deuxième compte de contrat',
      },
      finance: {
        transfer: 'transfert financier',
        account: 'compte financier',
        balance: 'équilibre',
        earn: 'intérêt accru',
        rate: "taux d'intérêt",
        confirm: 'Confirmer le transfert',
        transferAmount: 'Montant du transfert',
        all: 'tout transférer',
        coin: 'devise',
        open: 'Dossier de poste',
        close: 'Dossier de position fermé',
        fail: "l'opération a échoué",
        success: 'Opération réussie',
        updateTime: 'temps de mise à jour',
        financialManagement: 'Direction financière',
        financialOrder: 'Ordre financier',
      },
      record: {
        start_end: 'Début Fin',
        to: 'À',
        code: 'codage',
        remark: 'remarques',
        operatetype: "Type d'action",
        search: 'Chercher',
        charge: 'Charge',
        pickup: 'Ramasser',
        transaccount: 'Transfert',
        exchange: 'Échange',
        otcbuy: 'Achat OTC',
        otcsell: 'Vente OTC',
        activityaward: "Prix de l'activité",
        promotionaward: 'Prix de promotion',
        dividend: 'Dividende',
        vote: 'Voter',
        handrecharge: 'Recharge artificielle',
        match: 'Rencontre',
        chargetime: 'Temps de charge',
        type: 'Type',
        num: 'Montant',
        status: 'Statut',
        finish: 'Fini',
        fee: 'Frais',
        shouldfee: 'Frais à payer',
        discountfee: 'Frais de déduction',
        realfee: 'Frais de service',
        symbol: 'Symbole de la pièce',
        activitybuy: "Achat d'activité",
        ctcbuy: 'C2C BUY',
        ctcsell: 'C2C VENDRE',
        redout: 'RED-OUT',
        redin: 'RED-IN',
        quickExchange: 'Échange rapide',
        currentRate: 'Taux de change actuel',
        from: 'De',
        inputexchangeamount: "Saisir le montant d'échange rapide",
        inputexchangepasswd: "Saisir le mot de passe d'échange",
        chooseTransCoinUnit: 'Choisissez Trans Coin',
        inputTransAmount: 'Choisir le montant de la transaction',
        predictAmount: 'Échange',
        qamount: 'Amout',
        qrate: 'Taux',
        qexamount: "Montant de l'échange",
        withdrawcodein: 'Recharge WithdrawCode',
        withdrawcodeout: 'WithdrawCode Withdraw',
        contractfee: 'Frais de swap',
        contractprofit: 'Swap Profit',
        contractloss: 'Swap Loss',
        optionfail: 'Option Fail',
        optionfee: "Frais d'option",
        optionreward: "Récompense d'option",
        other: 'Autre',
      },
      recharge: {
        recharge: 'Dépôt',
        symbol: 'Pièce',
        address: 'Adresse de dépôt',
        copy: 'Copie',
        qrcode: 'QR Code',
        qrcodeaddress: 'QRCode pour le dépôt',
        msg1: "Ne rechargez aucun actif non monétaire à l'adresse ci-dessus, sinon les actifs ne seront pas récupérés.",
        msg2: "Après avoir rechargé à l'adresse ci-dessus, vous devez confirmer le nœud de réseau entier, après l'arrivée de 2 confirmations de réseau, après 6 confirmation du réseau peut être extraite.",
        msg3: 'Montant minimum de recharge:',
        msg3_1: ', une recharge inférieure au montant minimum ne sera pas comptabilisée.',
        msg4: 'Votre adresse de recharge ne changera pas fréquemment et vous pouvez répéter la recharge; en cas de changement, nous essaierons de vous en informer via une annonce sur le site Web ou par e-mail.',
        msg5: 'Assurez-vous de confirmer la sécurité de votre ordinateur et de votre navigateur pour éviter que les informations ne soient falsifiées ou fuites.',
        record: 'Enregistrement',
        copysuccess: 'Succès!',
        copyerr: 'Échec！ Veuillez le copier manuellement',
        time: "Heure d'arrivée",
        amount: 'Montant',
        gettingaddress: "Obtention de l'adresse de dépôt ， Veuillez patienter ...",
        getaddress: "Obtenir l'adresse de dépôt",
        memotips: 'Veuillez saisir ce mémo lors de la recharge, sinon vous perdrez des actifs.',
        withdrawrecharge: 'Recharge par code',
        coderechargetip: 'Veuillez saisir le code de retrait',
        rechargesuccess: 'Félicitations, Recharge success!',
        rechargeconfirm: 'Confirmer la recharge',
        status: 'Statut',
        protocol: 'Protocole réseau',
        status_0: 'échouer',
        status_1: 'non reçu',
        status_2: 'crédité',
        protocolerr: 'Veuillez sélectionner un accord',
        network: 'nœud',
        notaddress:
          "Vous n'avez pas demandé d'adresse de dépôt，Veuillez cliquer sur le bouton pour obtenir l'adresse de dépôt",
        rechargeDisable: 'La fonction de recharge est temporairement indisponible',
      },
      withdraw: {
        pickup: 'Ramasser',
        network: 'réseau de transfert',
        withdrawDisable: 'Suspendre les retraits',
        addressmanager: 'Gestion des adresses',
        withdrawbycode: 'Retirer par code',
        withdrawcode: 'Retirer le code',
        symbol: 'Pièce',
        address: 'Adresse',
        num: 'Montant',
        avabalance: 'Solde disponible',
        msg1: 'Le nombre de pièces est inférieur à',
        msg2: 'Arrive automatiquement au compte, sinon un examen manuel est requis',
        increase: 'Augmenter le crédit',
        tip1: "Entrez jusqu'à",
        tip11: 'décimales et la valeur minimale est',
        tip2: 'La valeur maximale est',
        numtip1: 'Entrez le nombre de pièces',
        fee: 'Frais',
        range: 'Intervalle',
        arriamount: "Le nombre d'arrivées",
        msg3: 'Le nombre minimum de pièces est',
        msg4: 'devise',
        msg5: "Afin d'assurer la sécurité des fonds, lorsque la politique de sécurité de votre compte change, que les mots de passe sont modifiés et que vous utilisez la nouvelle adresse pour retirer des pièces, nous procéderons à un audit manuel des pièces. Veuillez patienter et attendre le personnel pour appeler ou envoyer un e-mail. ",
        msg6: 'Assurez-vous de confirmer la sécurité de votre ordinateur et de votre navigateur pour éviter que les informations ne soient falsifiées ou fuites.',
        record: 'Enregistrement des retraits',
        symboltip: 'Veuillez sélectionner une devise',
        addresstip: "Merci de renseigner l'adresse",
        numtip2: 'Veuillez indiquer le nombre correct de pièces, la valeur minimale est',
        numtip3: 'Le montant de la monnaie ne doit pas être inférieur aux frais de traitement',
        amounttip: 'Veuillez saisir le montant',
        feetip1: 'Le tarif minimum est de',
        feetip2: 'La valeur maximale est',
        time: 'Heure de retrait',
        status: 'Statut',
        status_1: 'Traitement',
        status_2: 'Transfert',
        status_3: 'Échec',
        status_4: 'Succès',
        remark: 'Remarque',
        add: 'Ajouter',
        addresslist: "Liste d'adresses",
        safevalidate: 'Vérification de sécurité',
        telno: 'Tel',
        smscode: 'Code de vérification du téléphone',
        second: 'seconde',
        clickget: 'Avoir',
        email: 'Email',
        emailcode: "Code de vérification de l'e-mail",
        save: 'Sauver',
        delete: 'Effacer',
        telerr: 'Numéro de téléphone incorrect',
        emailerr: 'Adresse Email incorrecte',
        codeerr: 'Code de vérification incorrect',
        remarktip: 'Entrez la remarque',
        savemsg1: "Échec de l'enregistrement!",
        savemsg2: 'Enregistré avec succès!',
        operate: 'Exploiter',
        fundpwdtip: 'Veuillez saisir le mot de passe des fonds',
        click: 'Cliquez sur',
        filtrate: 'peut filtrer',
        txid: 'TxId',
        generateCode: 'Générer WithdrawCode',
        withdrawcodelist: 'Liste des codes de retrait',
        withdrawcodestatus: 'Statut',
        submit: 'Soumettre',
        generatecodesuccess: 'WithdrawCode généré!',
        code_status0: 'Inutilisé',
        code_status3: 'Succès',
        network: 'réseau de transfert',
        protocol: 'Protocole réseau',
      },
    },
    member: {
      usercenter: "Profil de l'utilisateur",
      securitycenter: 'Centre de sécurité',
      securitysetting: 'Paramètres de sécurité',
      accountsetting: 'Paramètre du compte',
      account: 'Compte',
      assets: 'La finance',
      exchange: 'Échange',
      curdelegate: 'Délégué actuel',
      hisdelegate: "Délégué d'histoire",
      otc: 'OTC',
    },
    order: {
      ordercenter: 'Centre de commande',
      myorder: 'Ma commande',
      myad: 'Mon annonce',
    },
    regist: {
      SaveKey: 'Veuillez sauvegarder la clé',
      zhanghaosiyao: 'Clé privée du compte',
      logintishi:
        'Pour vous connecter, vous n’avez besoin que de la clé privée du compte. La clé privée du compte est créée localement au hasard et doit être protégée par vous. Cliquez sur ok pour la copier automatiquement',
      nimingtishiTxt:
        'Entrez la clé privée du compte pour vous connecter au compte. La clé privée du compte est créée localement au hasard et doit être protégée par vous. Si vous la perdez, vous pouvez la récupérer via l’email lié au compte. Sinon, vous ne pourrez pas la récupérer!',

      shuruningcheng: 'Veuillez saisir votre surnom',
      anonymousLogin: 'Inscription anonyme',
      fillInvitationCode: "Remplir le Code d'invitation",
      go_login: 'Déjà un compte',
      go_login2: 'Aller au login',
      hasaccount: 'Avoir un compte？ Pour vous connecter',
      login: "S'identifier",
      username: "Nom d'utilisateur",
      country: 'Pays',
      smscode: 'Code de vérification SMS',
      sendcode: 'Envoyer',
      resendcode: 'Renvoyer (',
      pwd: 'Mot de passe',
      repwd: 'Confirmez le mot de passe',
      confrimpwd: 'Confirmer le mot de passe',
      agreement: 'l’acceptation',
      userprotocol: "Accord de l'utilisateur",
      privacypolicy: 'Politique de confidentialité',

      regist: "S'inscrire",
      teltip: 'Entrez tel',
      telerr: 'Erreur de format tél, entrez à nouveau',
      emailtip: 'Entrez votre e-mail',
      emailerr: "Erreur de format de l'e-mail, entrez à nouveau",
      confirmpwdtip: 'Entrez le mot de passe de confirmation',
      confirmpwderr: 'Deux mots de passe différents!',
      telregist: 'Tel Regist',
      emailregist: 'Registre des e-mails',
      usernametip: "Saisissez votre nom d'utilisateur",
      usernamemsg: "Longueur du nom d'utilisateur au moins 3, au plus 15",
      countrytip: 'Choisissez le pays',
      smscodetip: 'Entrez le code de vérification par SMS',
      pwdtip: 'Entrez le mot de passe de connexion',
      pwdmsg: "La longueur du mot de passe n'est pas inférieure à 6",
      telno: 'Tel',
      email: 'Email',
      agreementtip: 'Cliquez pour accepter',
      reloadChoice: 'Veuillez vous inscrire à nouveau',
      modaltitle: 'Veuillez vérifier',
      promotion: "Code d'invitation facultatif",
      china: 'Chine',
      singapore: 'Singapour',
      korea: 'Corée',
      japan: 'Japon',
      thailand: 'Thaïlande',
      russia: 'Russie',
      uk: 'Royaume-Uni',
      vietnam: 'vietnam',
      india: 'Inde',
      italy: 'Italie',
      hk: 'Hong Kong',
      malaysia: 'Malaisie',
      taiwan: 'Taïwan',
      turkey: 'dinde',
      germany: 'Allemagne',
      france: 'France',
      spain: 'Espagne',
      us: 'États Unis',
      canada: 'Canada',
    },
    safe: {
      oldprivateKey: 'Clé privée',
      privateKeytip: 'Veuillez saisir votre clé privée',
      safelevel_low: 'Niveau de sécurité: faible',
      safelevel_high: 'Niveau de sécurité: élevé',
      safelevel_medium: 'Niveau de sécurité: moyen',
      nickname: 'Surnom',
      bind: 'Lier',
      binded: 'Lié',
      verifypass: 'Vérifié',
      binding: 'Lier',
      binderr: 'Échec',
      bindretry: 'Retenter',
      verified: 'Vérifié',
      notverified: 'Non vérifié',
      verifiedtip:
        'Pour protéger la sécurité de votre compte, veuillez compléter la certification en nom réel avant de pouvoir échanger des opérations!',
      realname: 'Nom réel',
      idcard: "Carte d'identité",
      upload: 'Télécharger',
      upload_positive: "Télécharger une pièce d'identité avec photo avant",
      upload_negative: "Télécharger la photo inversée de la carte d'identité",
      upload_hand: "Télécharger des photos d'identité de l'ordinateur de poche",
      save: 'Sauver',
      reset: 'Réinitialiser',
      email: 'Email',
      bindemail: "Lier l'e-mail",
      loginpwd: 'Mot de passe',
      emailcode: "Code de vérification de l'e-mail",
      clickget: 'Cliquez pour obtenir',
      second: 's',
      phone: 'Telphone',
      bindphone: 'Lier le téléphone',
      phonecode: 'Code de vérification du téléphone',
      logintip: 'A utiliser lors de la connexion à la plateforme',
      edit: 'Modifier',
      oldpwd: 'Ancien mot de passe de connexion',
      newpwd: 'Nouveau mot de passe de connexion',
      confirmnewpwd: 'Confirmer le nouveau mot de passe',
      fundpwd: 'Mot de passe du fonds',
      fundtip:
        "Lorsque les fonds du compte changent, vous devez d'abord vérifier le mot de passe des fonds",
      set: 'Ensemble',
      confirmpwd: 'Confirmez le mot de passe',
      oldfundpwd: 'Ancien mot de passe du fonds',
      newfundpwd: 'Nouveau mot de passe du fonds',
      newpwdmsg1: 'Veuillez saisir au moins 6 nouveaux mots de passe de connexion',
      newpwdmsg2: 'Le nouveau mot de passe de connexion est incohérent',
      pwdmsg1: 'Veuillez saisir au moins 6 mots de passe',
      pwdmsg2: 'Mot de passe incohérent',
      emailtip: 'Veuillez entrer votre e-mail',
      codetip: 'Veuillez saisir le code de vérification',
      telnotip: 'Veuillez saisir le numéro de téléphone',
      oldpwdtip: "Veuillez saisir le mot de passe d'origine",
      realnametip: 'Veuillez entrer votre vrai nom',
      idcardtip: "Veuillez saisir le numéro d'identification",
      bindphonetip: "Veuillez d'abord lier votre téléphone!",
      resetfundpwd: 'Réinitialiser le mot de passe des fonds',
      upload_positivetip: "Veuillez télécharger le recto de la carte d'identité avec photo",
      upload_negativetip: "Veuillez télécharger la carte d'identité avec photo inversée",
      upload_handtip: "Veuillez télécharger des photos d'identité de l'ordinateur de poche",
      save_success: 'Succès!',
      save_failure: 'Échec!',
      imgtip: "Veuillez télécharger votre QRCode pour l'argent du récepteur",
      idcard_verifymsg1:
        "1. Le fichier mesure moins de 8 Mo. Les informations sur le document doivent être clairement visibles, aucune modification du document ou de la couverture par des objets étrangers n'est autorisée et le numéro et le nom du document doivent être visibles",
      idcard_verifymsg2:
        '2. La photo doit vous montrer sans chapeau. Il est recommandé de ne pas avoir de maquillage. Les traits du visage des porte-documents manuels doivent être nets et les bras doivent être complètement exposés.',
      idcard_verifymsg3:
        "3. Besoin de détenir à la fois des documents portatifs et une copie manuscrite (nom + date de candidature), 'Toutes mes actions sur ce site sont mes propres opérations, et je comprends les risques encourus et je suis prêt à en supporter toutes les conséquences juridiques Compte.'",
    },
    account: {
      successDelete: 'Suppression réussie',
      pagetitle: 'Lier le compte de nom réel',
      pagetip:
        "Veuillez définir votre mode de paiement, veuillez vous assurer d'utiliser mon vrai nom de compte",
      backcardno: 'Compte bancaire',
      backcardtip: 'Les informations personnelles de la carte bancaire ne sont pas liées',
      modify: 'Modifier',
      bind: 'Lier',
      name: 'Nom',
      bankaccount: 'Compte bancaire',
      bankbranch: 'Succursale bancaire',
      bankno: 'Numéro de banque',
      confirmbankno: 'Confirmer le numéro de carte',
      fundpwd: 'Mot de passe du fonds',
      save: 'Sauver',
      zfbaccount: 'Compte Alipay',
      zfbaccounttip: "Le compte personnel Alipay n'est pas lié",
      wxaccount: 'Compte Wechat',
      wxaccounttip: "Le compte personnel Wechat n'est pas lié",
      banknomsg1: 'Veuillez saisir le numéro de carte bancaire correct',
      banknomsg2: 'Le numéro de carte bancaire saisi deux fois est incohérent!',
      verifiedmsg: "Veuillez d'abord effectuer l'authentification du nom réel",
      bankaccountmsg: 'Veuillez sélectionner votre banque',
      bankbranchmsg: 'Veuillez entrer la succursale du compte',
      banknomsg: 'Veuillez saisir le numéro de carte bancaire correct',
      fundpwdmsg1: 'Veuillez saisir le mot de passe du fonds correct',
      fundpwdmsg2: 'Le mot de passe ne peut pas comporter moins de 6 caractères',
      zfbaccountmsg: 'Veuillez entrer un compte Alipay',
      wxaccountmsg: 'Veuillez entrer un compte WeChat',
      save_success: 'Succès!',
      save_failure: 'Échec!',
    },
    otcorder: {
      unpaid: 'Non payé',
      paided: 'Payé',
      finished: 'Fini',
      canceled: 'Annulé',
      appealing: 'Attrayant',
      searchtip: 'Entrez le numéro de commande',
      orderno: 'N ° de commande',
      created: 'Temps',
      symbol: 'Pièce',
      type: 'Type',
      type_sell: 'vendre',
      type_buy: 'acheter',
      tradename: 'TradeName',
      amount: 'Montant',
      money: 'Argent',
      fee: 'Frais',
    },
    identity: {
      certified: 'déjà certifié',
      placeholder: "Veuillez indiquer le motif de l'annulation",
      apply: 'Faire une demande pour devenir entreprise',
      become:
        'Devenez une entreprise certifiée NTL et bénéficiez de plus de privilèges de transaction',
      zhusnhu:
        'Les entreprises bénéficient de stands publicitaires exclusifs pour augmenter le succès des transactions',
      tijiaoziliao: "Soumettre les informations d'authentification du marchand",
      place:
        "Veuillez télécharger les informations d'authentification du commerçant préparées sur la plate-forme et les soumettre",
      tijiao: 'Votre audit de certification de marchand a été envoyé',
      tijiaosuc: 'Félicitations Votre certification de marchand est passée',
      tijiaofail: "Je suis désolé! La certification de votre marchand n'est pas passée",
      zhuxiaotijiao: "Votre demande d'annulation d'entreprise a été soumise",
      shenhefail: "Votre demande d'annulation d'entreprise n'a pas été approuvée",
      shenhesuc: "Votre demande d'annulation d'entreprise a été approuvée",
      shangjiazhuxiao: "annulation d'entreprise",
      shenagain: 'la revue',
      shenheshibai: "L'audit a échoué",
      sheqinggain: 'Postuler pour',
      reason: 'raison',
      shenqingtuibao: 'Demander un prêt',
      getquan: 'Vous disposez des autorisations suivantes',
      read: "J'ai lu et j'accepte",
      lijishenqing: 'Appliquer immédiatement',
      tips: 'prompt',
      wufachexiao:
        "Vous êtes dans l'opération d'annulation commerciale, après confirmation de la soumission de l'opération de candidature, celle-ci ne pourra pas être révoquée.",
      suredo: "Etes-vous sûr que c'est fait?",
      shuzizichan: "Certificat de trading d'actifs numériques",
      gerenzichan: "Certificat d'actif numérique personnel",
      second: {
        line: 'Comment postuler pour affaires?',
        step1: "Étape 1: préparer les documents d'application commerciale selon les besoins",
        step1c1: "Préparez l'application suivante:",
        step1c2:
          "Numéro de téléphone portable, identifiant WeChat, numéro QQ, certificat d'actif numérique personnel (photo), certificat de transaction d'actif numérique (photo)",
        step2: 'Étape 2: soumettre la candidature',
        step2c:
          "Pour compléter les documents d'audit de certification d'entreprise qui doivent être remplis et téléchargés, cliquez sur Soumettre pour approbation.",
        step3: 'Étape 3: audit des données',
        stepc:
          "Nous examinerons vos applications commerciales dans les trois à cinq prochains jours, veuillez garder les yeux ouverts, mais vous pouvez soumettre une page. Après l'approbation, vous pouvez publier l'annonce dans la zone de change française.",
        agree: 'A accepté de geler',
        agreec: 'En tant que dépôt marchand',
        shenqingchngweishangjia: 'Postuler pour une entreprise',
      },
      yuanyin: 'raison',
      bizhong: 'Monnaie de dépôt',
      shuliang: 'Montant de la marge',
      chosen: 'Sélectionnez la devise',
      seat: 'Stand exclusif',
      service: 'Service individuel',
      lowfee: 'Frais moins élevés',
      phone: 'Téléphone',
      balance: 'Biens personnels',
      cardphoto: "Photos d'identité positives et négatives",
      wx: 'Wechat',
      exchange: "S'engager dans des opérations hors bourse d'actifs numériques",
      handphoto: "Photo d'identité de l'utilisateur",
      qq: 'QQ',
      ploy: 'Existe-t-il une stratégie de contrôle des risques correspondante',
      agreement: '《Contrat de marchand certifié》',
      he: 'et',
      applyfor: 'Appliquer',
      sendcode: 'Envoyer',
      confirm: 'Confirmer',
      prepare: 'Préparer le matériel',
      result: 'Attendez le résultat',
      review: 'Poster le commentaire',
      passed: 'Examen réussi',
      approve: 'Veuillez accepter le contrat de certification marchand',
      emailtip1: 'Veuillez envoyer les documents suivants par e-mail à',
      emailtip2: 'Nous examinerons votre candidature dans les plus brefs délais.',
    },
    extension: {
      title1: 'Liens de promotion',
      title2: 'Amis de promotion',
      title3: 'Ma commission',
      linkdesc:
        "L'URL suivante est votre adresse de promotion auprès du monde extérieur. Vous pouvez la promouvoir via des amis, QQ, Wechat, Weibo, des blogs, des forums ou votre propre site Web. Toutes les personnes qui ont accédé via cette adresse seront vos utilisateurs après l'inscription ., Et lorsque ces utilisateurs soumettent des stratégies sur ce site, vous pouvez gagner des commissions et une promotion détaillée peut être consultée dans l'enregistrement d'accès. ",
      linktitle: "Vos liens d'amour",
      copy: 'Copie',
      copy_msg1: 'Copie réussie！',
      copy_msg2: 'Échec！ Veuillez le copier manuellement',
      username: 'Nom',
      currrecharge: 'Transaction',
      userlevel: "Niveau de l'utilisateur",
      createdtime: "Heure d'enregistrement",
      currcommission: 'Commission actuelle',
      managerfee: 'frais de gestion',
      yuan: 'yuan (RMB)',
      symbol: 'PIÈCE',
      amount: 'Montant',
      remark: 'Remarque',
      amounttime: 'Deliver Time',
    },
    promotion: {
      title: 'Centre de promotion',
      subtitle1: 'Mes cartes',
      subtitle2: 'Exchange Records',
      subtitle3: 'Ma promotion',
      card_column0: "Code d'échange",
      card_column1: 'Nom',
      card_column2: 'Symbole de la pièce',
      card_column3: 'Montant',
      card_column4: 'Date limite',
      card_column5: 'Total',
      card_column6: 'Échangé',
      card_column7: 'Créer du temps',
      my_column0: 'Inviter un utilisateur',
      my_column1: "Date d'enregistrement",
      my_column2: 'Vrai nom',
      gopromotion: 'Promotion',
      inputcardno: 'Veuillez saisir le code de la carte',
      exchange: 'Échange',
      exchangesuccess: "Félicitations！ Vous pouvez vérifier l'actif dans le centre financier！",
      exchangewithcode: 'Échange avec code',
    },
    activity: {
      navTitle: 'Innovation',
      subNavTitle1: 'Mes commandes',
      subNavTitle2: 'Mes mines',
      subNavTitle3: 'Mon verrouillé',
      column1: 'Nom',
      column2: 'Type',
      column3: 'Montant',
      column4: 'Unité (IN)',
      column5: 'Unité (OUT)',
      column6: 'Statut',
      column7: "Chiffre d'affaires",
      column8: 'Créer du temps',
      mColumn1: 'Image',
      mColumn2: 'Nom',
      mColumn3: 'Pièce de monnaie',
      mColumn4: 'Période',
      mColumn5: 'MiningDays',
      mColumn6: 'MiningedDays',
      mColumn7: 'Statut',
      mColumn8: 'Capacité de base',
      mColumn9: 'Capacité actuelle',
      mColumn10: 'Total extrait',
      mColumn11: 'Date de fin',
      mColumn12: 'Créer un rendez-vous',
      lColumn1: 'Image',
      lColumn2: 'Nom',
      lColumn3: 'Pièce de monnaie',
      lColumn4: 'Période',
      lColumn5: 'LockedDays',
      lColumn6: 'ReleasedDays',
      lColumn7: 'Statut',
      lColumn8: 'Capacité de base',
      lColumn9: 'Capacité actuelle',
      lColumn10: 'Total publié',
      lColumn11: 'Date de fin',
      lColumn12: 'Créer un rendez-vous',
    },
    mining: {
      title: 'Ma liste minière',
      empty: "Pas d'enregistrements",
      day: 'Journée',
      week: 'La semaine',
      month: 'Mois',
      year: 'An',
      invitetip1:
        'La capacité de la machine minière peut être améliorée en invitant des amis. Chaque personne invitée à échanger la machine minière augmentera la capacité',
      invitetip2: "Limite supérieure d'augmentation de capacité",
      miningUnit: 'Unité minière',
      miningPeriod: "Période d'exploitation",
      miningDays: 'Mining Times',
      miningedDays: 'Temps miné',
      miningDaysProfit: 'Sortie de base',
      miningCurrentDaysProfit: 'Sortie courant',
      status0: 'A déployer',
      status1: 'Déployé',
      status2: 'Plus de',
    },
    locked: {
      title: 'Ma liste verrouillée',
      empty: "Pas d'enregistrements",
      day: 'Journée',
      week: 'La semaine',
      month: 'Mois',
      year: 'An',
      invitetip1:
        'La capacité du verrouillé peut être améliorée en invitant des amis. Chaque personne invitée à échanger le verrouillé augmentera la capacité',
      invitetip2: "Limite supérieure d'augmentation de capacité",
      miningUnit: 'Unité de libération',
      miningPeriod: 'Période de sortie',
      miningDays: 'Heures de sortie',
      miningedDays: 'Temps de sortie',
      miningDaysProfit: 'Sortie de base',
      miningCurrentDaysProfit: 'Sortie courant',
      status0: 'Pour être libéré',
      status1: 'Libérer',
      status2: 'Plus de',
      totallocked: 'Total verrouillé',
    },
    api: {
      apiAdmin: 'Gestion des API',
      createApi: 'Créer une nouvelle clé API',
      mark: 'remarque',
      bindAddress: "La clé d'adresse IP indépendante est valide pendant 90 jours",
      hint: 'indice',
      part1:
        "Nous mettons à votre disposition une API puissante, vous pouvez utiliser des requêtes de marché, des transactions automatiques et d'autres services",
      apiDoc: "par la documentation de l'API.",
      howUse: 'Découvrez comment utiliser',
      // part2: "Chaque utilisateur crée jusqu'à cinq ensembles de clés API",
      part2: "Créez jusqu'à 5 ensembles de clés API par utilisateur",
      part3:
        "Veuillez ne pas divulguer votre clé API pour éviter la perte d'actifs. Pour des raisons de sécurité, il est recommandé de lier l'IP pour la clé API, avec un maximum de 5 IP pour chaque clé API. Renseignez une seule adresse directement, plusieurs adresses IP à moitié Virgules angulaires, telles que 192.168.1.1, 192.168.1.2 à la place, 192.168.1.3. ",
      myApiKey: 'Ma clé API',
      ipAddress: 'Adresse IP',
      // createTime: "temps de creation",
      createTime: 'Créer du temps',
      accessKey: "Clé d'accès",
      bindIpAddress: "Lier l'adresse IP",
      // ioDays: "Période de validité restante (jours)",
      ioDays: 'Les jours restants',
      operation: 'opération',
      create: 'créer',
      edit: 'Éditer',
      delete: 'effacer',
      sureDelete: 'Êtes-vous sûr de vouloir supprimer?',
      tips: "La clé ne s'affiche que lorsqu'elle est ajoutée, veuillez la sauvegarder à temps.",
      copy: 'copie',
      access: 'clé',
      okText: 'sûr',
      cancel: 'Annuler',
    },
  },
  cms: {
    NewExclusive: 'Exclusif pour nouveaux arrivants',
    Newtip:
      'Inscrivez-vous à un compte NTL pour inviter des amis et avoir la chance de profiter d’une remise à vie',
    noticecenter: "Centre d'annonces",
    newshelp: 'Aide aux nouveaux utilisateurs',
    appdownload: "Télécharger l'application",
    onlineservice: 'un service en ligne',
    faq: 'FAQ',
    notice: 'Annonce',
    servicecenter: 'Centre client',
    about: 'À propos',
    joinus: 'Rejoignez-nous',
    aboutus: 'À propos de nous',
    exchangerule: 'Règles de négociation',
    useprotocol: "Contrat d'utilisation",
    feenote: 'Description des frais',
    merchantprocotol: 'Contrat marchand',
    features: 'Traits',
    contactus: 'Nous contacter',
    noticelist: 'Toutes les annonces',
    nextnotice: 'PROCHAIN',
    prevnotice: 'PREV',
    notexist: "La page que vous avez visitée n'existe pas ou a été supprimée",
    otherhelp: 'Autre dans cette catégorie',
    scanforshare: 'Rechercher un partage',
    download: 'Télécharger',
    downloadslogan: 'NTL APP - Commerce partout.',
  },
  description: {
    title1: 'Sécurité',
    title2: 'Service 24H',
    title3: 'Global Exchange',
    title4: 'Projet strictement',
    message1:
      'Système complet de contrôle du vent financier et système antivol, portefeuille chaud et froid, système multi-signature pour assurer la sécurité des fonds',
    message2:
      "Un audit manuel en ligne 24h / 24 peut empêcher les clients de rater les meilleures opportunités d'investissement.",
    message3:
      'La couverture du réseau mondial de services aux entreprises vous aide à investir dans des actifs chiffrés mondiaux et à effectuer des transactions avec des utilisateurs mondiaux',
    message4:
      'Nous sélectionnons strictement ces projets blockchain de haute qualité pour filtrer 80% des projets à très haut risque pour vous.',
    scanqrcode: "Scanner le code QR, télécharger l'application",
    aboutdesc1:
      "ntlex.com est une plateforme de trading d'actifs numériques leader dans le monde, enregistrée aux îles Caïmans, avec une équipe opérationnelle de base à Hong Kong. Les principaux membres de ntlex.com proviennent de grandes sociétés Internet et financières. La plupart d'entre eux croient fermement au Bitcoin et aux chaînes de blocs. Nous sommes convaincus que les chaînes de blocs changeront le système financier monopolistique traditionnel et bâtiront une structure sociale plus démocratique et autonome. ",
    aboutdesc2:
      "La plate-forme ntlex.com a une architecture de trading professionnelle au niveau financier, un moteur de trading de correspondance haute mémoire simultanée auto-développé. La plate-forme utilise un système de portefeuille rechargeable à froid + signatures multiples + système d'attaque DDOS haute protection et autres architecture de trading pour garantir la sécurité des actifs du client. ",
    aboutdesc3:
      "Afin de permettre aux clients de mieux saisir les opportunités d'investissement, ntlex.com adopte une gestion plate dans le service client, et met en place un mécanisme de réponse de service extrêmement rapide. Le responsable du service client des actifs est en ligne 7 * 24H toute l'année round, fournissant aux clients des services tels que la recharge et l'encaissement des actifs, et s'assurant que les clients se rechargent complètement en 25 minutes. ",
    aboutdesc4:
      "ntlex.com sélectionne strictement les projets de haute qualité et fournit des services d'hébergement d'actifs sûrs et stables. ntlex.com défend le concept' d'honnêteté, de justice, d'enthousiasme et d'ouverture 'et s'efforce de créer un site sûr, fiable, échange ultime efficace et convivial pour les utilisateurs. ",
    aboutdesc5:
      "Bien que les actifs numériques ne soient actuellement que dans un petit cercle, nous pensons que ce type d'actifs que tout le monde peut saisir pleinement sera populaire à l'avenir. Travaillons ensemble et attendons avec impatience!",
    aboutdesc6:
      "ntlex.com (Nano Token Liquidity) est une plateforme de trading de dérivés d'actifs numériques internationale basée sur la gouvernance d'une organisation autonome décentralisée (DAO). Son objectif est de fournir des services de trading d'actifs de blockchain sécurisés, stables, pratiques, équitables et réputés pour les utilisateurs du monde entier.",
    aboutdesc7:
      "L'NTL DAO autorise la Fondation des îles Caïmans à gérer ntlex.com, une structure de gouvernance qui offre des avantages supérieurs aux bourses de cryptomonnaies traditionnelles et qui garantit efficacement l'équité et la sécurité des actifs des utilisateurs. Les membres de l'équipe de gestion proviennent de plusieurs pays et régions du monde, les membres clés ayant travaillé chez Coinbase, Binance, Morgan Stanley, Amazon, Google et d'autres entreprises financières et technologiques mondialement connues. Ils ont une solide capacité de gestion stratégique mondiale et une riche expérience dans le contrôle des risques financiers.",
    aboutdesc8:
      "ntlex.com offre une gamme complète de services d'actifs de cryptomonnaie, y compris les paires de devises, les contrats perpétuels, les marchandises au comptant, les options, les NFT, les prêts et les emprunts, ainsi que des versions en plusieurs langues telles que le chinois, l'anglais, le japonais et le coréen. Sa solution technique est basée sur Amazon AWS et Google Cloud, et peut efficacement prévenir les attaques DDOS, prendre en charge la séparation dynamique et statique des données, le cache de données chaudes, la récupération en cas de sinistre en dehors de la région et l'extension parallèle. L'architecture technique de pointe au niveau mondial garantit des transactions sécurisées pour les utilisateurs, avec des fonctionnalités telles que l'accès instantané aux actifs de blockchain, la technologie de partage d'adresses multidevises et la protection de la sécurité à plusieurs niveaux. De plus, ntlex.com propose des frais de transaction de cryptomonnaie et de retrait relativement bas dans l'industrie.",
    aboutdesc9:
      "En tant qu'échange de gouvernance DAO fiable pour les utilisateurs, ntlex.com s'engage à garantir la sécurité des informations de transaction et des actifs des utilisateurs, tout en offrant une expérience de trading exceptionnelle.",
    support: 'Soutien',
    report: 'Suggestion',
    service: 'Service Clients',
    apply: "Demande d'inscription",
    coop: 'La coopération',
    community: 'Communauté NTL',
    wechat: 'Wechat',
    addwechat: "Ajoutez 'bmate601' comme amis Wechat, puis entrez dans la communauté Wechat",
    weibo: 'Weibo',
    twitter: 'Twitter',
    biyong: 'Biyong',
    telegram: 'Télégramme',
    medium: 'Moyen',
    reddit: 'Reddit',
  },
  bzb_description: {
    title1: '',
    title2: '',
    title3: '',
    title4: '',
    title5: '',
    title6: '',
    title7: '',
    title8: '',
    desc1: '',
    desc2: '',
    desc3: '',
    desc4: '',
    desc5: '',
    desc6: '',
    desc7: '',
    desc8: '',
  },
  footer: {
    wechatkefu: 'service wechat',
    notice: 'Annonce',
    gsmc: 'Échangez la meilleure crypto-monnaie',
    bah: 'N ° 13026899 -3, Shanghai ICP',
    gsjj: 'Profil',
    gywm: 'À propos de nous',
    jrwm: 'Rejoignez-nous',
    biyong: 'BiYong',
    lxwm: 'Nous contacter',
    yqlj: 'Liens',
    bzzx: 'Aidez-moi',
    xsrm: 'Cours pour débutants',
    czzn: 'Guide de recharge',
    jyzn: 'Guide commercial',
    ptsm: 'Explique',
    fysm: 'Frais',
    fwtk: 'Politique de service',
    fltk: 'politique juridique',
    wechat: 'Service client Wechat',
    xszn: 'Guide du débutant',
    cjwt: 'FAQ',
    mztk: 'Avertissement',
    ystk: 'Politique de confidentialité',
    tkxy: 'Conditions',
    gybzb: 'À propos de BZB',
    kfyx: 'Service Mailbox',
    swhz: 'La coopération',
    sbsq: 'Application de marché',
    bzzl: 'Informations sur la pièce',
    tsjb: 'Rapport',
    apidoc: 'Api Doc',
    zwkf: 'Arrive bientôt',
  },
  index: {
    circulation: 'Circulation des fonds de sécurité et de développement',
    hourEth: "Revenus cumulés à distribuer aujourd'hui",
    yesterdayEth: 'Revenus cumulés à distribuer hier',
    yesterday: 'Sortie minière de la veille:',
    bhbTotal: 'Flux total BHB',
    bhbSecond: 'BHB Two level market circulation',
    checkMineprinciple: 'Voir le principe du minage',
    checkFlowVolum: 'Contrôle de la circulation',
    checkLockPosition: 'Vérifiez la situation de verrouillage',
    BHBregister: 'Enregistrement du compte NTL',
    tibi: "L'heure et la limite du paiement de l'argent à la facture",
    line_plane:
      'Annonce sur le plan en ligne de BHB, la diffusion et le retour des frais de service',
    fenpeijizhi: 'Une description du mécanisme de distribution des revenus de NTL',
    jiangli_jihua: 'Inviter le programme de récompenses minières',
    friend_fanhuan: 'Invitez des amis, gagnez des frais supplémentaires et revenez',
  },
  plate: {
    title: 'Système de distribution des revenus de la plateforme （Fonds propres BHB',
    content1:
      "Comme décrit dans le livre blanc, NTL occupera 80% de la plateforme (après déduction des taxes et frais). Les revenus sont alloués aux détenteurs de BHB, et 20% des revenus sont utilisés pour soutenir la R&D et l'exploitation de la plateforme. . ",
    content2:
      'La distribution des revenus prend des jours comme cycle de distribution et le 6 juin 2018 comme premier jour de distribution. Chaque jour suivant, le revenu total à distribuer le jour précédent sera réparti proportionnellement entre les détenteurs de BHB.',
    content3:
      '（Avis ： 1. Le BHB ici se réfère uniquement au BHB qui a été libéré / diffusé. Voir aussi 【',
    content3_1: 'Note sur le ratio diffusion BHB / participation à la distribution des revenus',
    content3_2:
      "2. l'instantané horaire (point entier) est calculé une fois et la répartition des revenus est exécutée une fois par jour.",
    hourFenpei: "Répartition des revenus aujourd'hui",
    hourTotal: "Revenu total de la plateforme d'aujourd'hui",
    xiangqing: 'Détails de la répartition actuelle des revenus',
    yesterdaytit: 'Distribution des revenus hier',
    yesterdaytotal: "Revenu total de la plateforme d'hier",
    yesterdayxiangqing: "Détails de la répartition des revenus d'hier",
    yesterday: {
      total: 'Revenus totaux',
      allocated: 'Revenus non distribués',
    },
  },
  feereturn: {
    ruletitle: 'Remarque',
    rulecontent:
      "Notre livre blanc contient une explication détaillée du remboursement des frais de transaction. Dans l'ensemble, 51% de la base BHB totale de la plateforme" +
      "(désormais appelée' partie récompense de la communauté ') seront remboursés aux utilisateurs au fil du temps via notre mécanisme 'Trans-Fee Mining'. Cependant, une fois que ces 51% du total des BHB auront été entièrement libérés par remboursement, le mécanisme 'Trans-Fee Mining' prendra fin automatiquement. ",
    recordtitle: 'Liste',
    recordcontent:
      'Tous les jours (UTC + 8, comme ci-dessous) BHB remboursera 100% des frais de transaction des utilisateurs' +
      'encourus la veille sous la forme de BHB. Cela se fera en utilisant le prix BHB moyen de la veille (ce prix moyen est calculé en tant que valeur totale de la transaction / volume total de la transaction). Nous effectuerons ce remboursement des frais de transaction de la veille sous forme de BHB, à 11 heures tous les jours. ',
    time: 'Date',
    todaycharge: 'Prix moyen (ETH)',
    totalChange: 'Total (ETH)',
    returnCharge: 'Remboursement Trans-Fee Mining (BHB)',
    todayChargeReturn: "Programme d'incitation au remboursement FCoin （BHB）",
  },
};
